!(function(t) {
  var e = {};
  function n(r) {
    if (e[r]) return e[r].exports;
    var o = (e[r] = { i: r, l: !1, exports: {} });
    return t[r].call(o.exports, o, o.exports, n), (o.l = !0), o.exports;
  }
  (n.m = t),
    (n.c = e),
    (n.d = function(t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: r });
    }),
    (n.r = function(t) {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(t, '__esModule', { value: !0 });
    }),
    (n.t = function(t, e) {
      if ((1 & e && (t = n(t)), 8 & e)) return t;
      if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (
        (n.r(r),
        Object.defineProperty(r, 'default', { enumerable: !0, value: t }),
        2 & e && 'string' != typeof t)
      )
        for (var o in t)
          n.d(
            r,
            o,
            function(e) {
              return t[e];
            }.bind(null, o),
          );
      return r;
    }),
    (n.n = function(t) {
      var e =
        t && t.__esModule
          ? function() {
              return t.default;
            }
          : function() {
              return t;
            };
      return n.d(e, 'a', e), e;
    }),
    (n.o = function(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (n.p = ''),
    n((n.s = 13));
})([
  function(t, e) {
    function n() {
      return (
        (t.exports = n =
          Object.assign ||
          function(t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = arguments[e];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
            }
            return t;
          }),
        n.apply(this, arguments)
      );
    }
    t.exports = n;
  },
  function(t, e) {
    t.exports = function(t, e, n) {
      return (
        e in t
          ? Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (t[e] = n),
        t
      );
    };
  },
  function(t, e) {
    t.exports = function(t, e) {
      if (!(t instanceof e))
        throw new TypeError('Cannot call a class as a function');
    };
  },
  function(t, e) {
    function n(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          'value' in r && (r.writable = !0),
          Object.defineProperty(t, r.key, r);
      }
    }
    t.exports = function(t, e, r) {
      return e && n(t.prototype, e), r && n(t, r), t;
    };
  },
  function(t, e) {
    function n(e) {
      return (
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? (t.exports = n = function(t) {
              return typeof t;
            })
          : (t.exports = n = function(t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            }),
        n(e)
      );
    }
    t.exports = n;
  },
  function(t, e, n) {
    var r = n(4),
      o = n(10);
    t.exports = function(t, e) {
      return !e || ('object' !== r(e) && 'function' != typeof e) ? o(t) : e;
    };
  },
  function(t, e) {
    function n(e) {
      return (
        (t.exports = n = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
        n(e)
      );
    }
    t.exports = n;
  },
  function(t, e, n) {
    var r = n(11);
    t.exports = function(t, e) {
      if ('function' != typeof e && null !== e)
        throw new TypeError(
          'Super expression must either be null or a function',
        );
      (t.prototype = Object.create(e && e.prototype, {
        constructor: { value: t, writable: !0, configurable: !0 },
      })),
        e && r(t, e);
    };
  },
  function(t, e, n) {
    t.exports = (function() {
      return (
        (n = {}),
        (t.m = e = [
          function(t, e, n) {
            var r = n(10),
              o = {},
              i = !1;
            function a(t, e) {
              return e === s(t);
            }
            function s(t) {
              var e = typeof t;
              return 'object' != e
                ? e
                : t
                ? t instanceof Error
                  ? 'error'
                  : {}.toString
                      .call(t)
                      .match(/\s([a-zA-Z]+)/)[1]
                      .toLowerCase()
                : 'null';
            }
            function u(t) {
              return a(t, 'function');
            }
            function c(t) {
              var e = Function.prototype.toString
                  .call(Object.prototype.hasOwnProperty)
                  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
                  .replace(
                    /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                    '$1.*?',
                  ),
                n = RegExp('^' + e + '$');
              return l(t) && n.test(t);
            }
            function l(t) {
              var e = typeof t;
              return null != t && ('object' == e || 'function' == e);
            }
            function p(t, e, n) {
              var r,
                o,
                i,
                s = a(t, 'object'),
                u = a(t, 'array'),
                c = [];
              if (s && -1 !== n.indexOf(t)) return t;
              if ((n.push(t), s))
                for (r in t)
                  Object.prototype.hasOwnProperty.call(t, r) && c.push(r);
              else if (u) for (i = 0; i < t.length; ++i) c.push(i);
              var l = s ? {} : [],
                p = !0;
              for (i = 0; i < c.length; ++i)
                (o = t[(r = c[i])]),
                  (l[r] = e(r, o, n)),
                  (p = p && l[r] === t[r]);
              return 0 == c.length || p ? t : l;
            }
            function f() {
              var t = b();
              return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                /[xy]/g,
                function(e) {
                  var n = (t + 16 * Math.random()) % 16 | 0;
                  return (
                    (t = Math.floor(t / 16)),
                    ('x' === e ? n : (7 & n) | 8).toString(16)
                  );
                },
              );
            }
            i ||
              ((i = !0),
              a(JSON, 'undefined') ||
                (c(JSON.stringify) && (o.stringify = JSON.stringify),
                c(JSON.parse) && (o.parse = JSON.parse)),
              (u(o.stringify) && u(o.parse)) || n(11)(o));
            var d = {
              strictMode: !1,
              key: [
                'source',
                'protocol',
                'authority',
                'userInfo',
                'user',
                'password',
                'host',
                'port',
                'relative',
                'path',
                'directory',
                'file',
                'query',
                'anchor',
              ],
              q: { name: 'queryKey', parser: /(?:^|&)([^&=]*)=?([^&]*)/g },
              parser: {
                strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
                loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
              },
            };
            function h(t, e) {
              var n, r;
              try {
                n = o.stringify(t);
              } catch (o) {
                if (e && u(e))
                  try {
                    n = e(t);
                  } catch (t) {
                    r = t;
                  }
                else r = o;
              }
              return { error: r, value: n };
            }
            function m(t, e) {
              return function(n, r) {
                try {
                  e(n, r);
                } catch (n) {
                  t.error(n);
                }
              };
            }
            var g = ['log', 'network', 'dom', 'navigation', 'error', 'manual'],
              v = ['critical', 'error', 'warning', 'info', 'debug'];
            function y(t, e) {
              for (var n = 0; n < t.length; ++n) if (t[n] === e) return !0;
              return !1;
            }
            function b() {
              return Date.now ? +Date.now() : +new Date();
            }
            t.exports = {
              addParamsAndAccessTokenToPath: function(t, e, n) {
                (n = n || {}).access_token = t;
                var r,
                  o = [];
                for (r in n)
                  Object.prototype.hasOwnProperty.call(n, r) &&
                    o.push([r, n[r]].join('='));
                var i = '?' + o.sort().join('&');
                (e = e || {}).path = e.path || '';
                var a,
                  s = e.path.indexOf('?'),
                  u = e.path.indexOf('#');
                -1 !== s && (-1 === u || s < u)
                  ? ((a = e.path),
                    (e.path = a.substring(0, s) + i + '&' + a.substring(s + 1)))
                  : -1 !== u
                  ? ((a = e.path),
                    (e.path = a.substring(0, u) + i + a.substring(u)))
                  : (e.path = e.path + i);
              },
              createItem: function(t, e, n, o, i) {
                for (
                  var a, u, c, l, p, d, h = [], g = 0, v = t.length;
                  g < v;
                  ++g
                ) {
                  var y = s((d = t[g]));
                  switch (y) {
                    case 'undefined':
                      break;
                    case 'string':
                      a ? h.push(d) : (a = d);
                      break;
                    case 'function':
                      l = m(e, d);
                      break;
                    case 'date':
                      h.push(d);
                      break;
                    case 'error':
                    case 'domexception':
                    case 'exception':
                      u ? h.push(d) : (u = d);
                      break;
                    case 'object':
                    case 'array':
                      if (
                        d instanceof Error ||
                        ('undefined' != typeof DOMException &&
                          d instanceof DOMException)
                      ) {
                        u ? h.push(d) : (u = d);
                        break;
                      }
                      if (o && 'object' === y && !p) {
                        for (var w = 0, _ = o.length; w < _; ++w)
                          if (void 0 !== d[o[w]]) {
                            p = d;
                            break;
                          }
                        if (p) break;
                      }
                      c ? h.push(d) : (c = d);
                      break;
                    default:
                      if (
                        d instanceof Error ||
                        ('undefined' != typeof DOMException &&
                          d instanceof DOMException)
                      ) {
                        u ? h.push(d) : (u = d);
                        break;
                      }
                      h.push(d);
                  }
                }
                0 < h.length && ((c = r(c)).extraArgs = h);
                var x = {
                  message: a,
                  err: u,
                  custom: c,
                  timestamp: b(),
                  callback: l,
                  notifier: n,
                  diagnostic: {},
                  uuid: f(),
                };
                return (
                  c &&
                    void 0 !== c.level &&
                    ((x.level = c.level), delete c.level),
                  o && p && (x.request = p),
                  i && (x.lambdaContext = i),
                  (x._originalArgs = t),
                  x
                );
              },
              createTelemetryEvent: function(t) {
                for (var e, n, r, o, i = 0, a = t.length; i < a; ++i)
                  switch (s((o = t[i]))) {
                    case 'string':
                      !e && y(g, o) ? (e = o) : !r && y(v, o) && (r = o);
                      break;
                    case 'object':
                      n = o;
                  }
                return { type: e || 'manual', metadata: n || {}, level: r };
              },
              filterIp: function(t, e) {
                if (t && t.user_ip && !0 !== e) {
                  var n = t.user_ip;
                  if (e)
                    try {
                      var r;
                      if (-1 !== n.indexOf('.'))
                        (r = n.split('.')).pop(),
                          r.push('0'),
                          (n = r.join('.'));
                      else if (-1 !== n.indexOf(':')) {
                        if (2 < (r = n.split(':')).length) {
                          var o = r.slice(0, 3),
                            i = o[2].indexOf('/');
                          -1 !== i && (o[2] = o[2].substring(0, i)),
                            (n = o
                              .concat('0000:0000:0000:0000:0000')
                              .join(':'));
                        }
                      } else n = null;
                    } catch (t) {
                      n = null;
                    }
                  else n = null;
                  t.user_ip = n;
                }
              },
              formatArgsAsString: function(t) {
                var e,
                  n,
                  r,
                  o = [];
                for (e = 0, n = t.length; e < n; ++e) {
                  switch (s((r = t[e]))) {
                    case 'object':
                      500 < (r = (r = h(r)).error || r.value).length &&
                        (r = r.substr(0, 497) + '...');
                      break;
                    case 'null':
                      r = 'null';
                      break;
                    case 'undefined':
                      r = 'undefined';
                      break;
                    case 'symbol':
                      r = r.toString();
                  }
                  o.push(r);
                }
                return o.join(' ');
              },
              formatUrl: function(t, e) {
                if (
                  (!(e = e || t.protocol) &&
                    t.port &&
                    (80 === t.port
                      ? (e = 'http:')
                      : 443 === t.port && (e = 'https:')),
                  (e = e || 'https:'),
                  !t.hostname)
                )
                  return null;
                var n = e + '//' + t.hostname;
                return (
                  t.port && (n = n + ':' + t.port), t.path && (n += t.path), n
                );
              },
              get: function(t, e) {
                if (t) {
                  var n = e.split('.'),
                    r = t;
                  try {
                    for (var o = 0, i = n.length; o < i; ++o) r = r[n[o]];
                  } catch (t) {
                    r = void 0;
                  }
                  return r;
                }
              },
              handleOptions: function(t, e, n) {
                var o = r(t, e, n);
                return (
                  !e ||
                    e.overwriteScrubFields ||
                    (e.scrubFields &&
                      (o.scrubFields = (t.scrubFields || []).concat(
                        e.scrubFields,
                      ))),
                  o
                );
              },
              isError: function(t) {
                return a(t, 'error') || a(t, 'exception');
              },
              isFunction: u,
              isIterable: function(t) {
                var e = s(t);
                return 'object' === e || 'array' === e;
              },
              isNativeFunction: c,
              isType: a,
              isObject: l,
              isString: function(t) {
                return 'string' == typeof t || t instanceof String;
              },
              jsonParse: function(t) {
                var e, n;
                try {
                  e = o.parse(t);
                } catch (t) {
                  n = t;
                }
                return { error: n, value: e };
              },
              LEVELS: { debug: 0, info: 1, warning: 2, error: 3, critical: 4 },
              makeUnhandledStackInfo: function(t, e, n, r, o, i, a, s) {
                var u = { url: e || '', line: n, column: r };
                (u.func = s.guessFunctionName(u.url, u.line)),
                  (u.context = s.gatherContext(u.url, u.line));
                var c = document && document.location && document.location.href,
                  l = window && window.navigator && window.navigator.userAgent;
                return {
                  mode: i,
                  message: o ? String(o) : t || a,
                  url: c,
                  stack: [u],
                  useragent: l,
                };
              },
              merge: r,
              now: b,
              redact: function() {
                return '********';
              },
              sanitizeUrl: function(t) {
                var e = (function(t) {
                  if (a(t, 'string')) {
                    for (
                      var e = d,
                        n = e.parser[e.strictMode ? 'strict' : 'loose'].exec(t),
                        r = {},
                        o = 0,
                        i = e.key.length;
                      o < i;
                      ++o
                    )
                      r[e.key[o]] = n[o] || '';
                    return (
                      (r[e.q.name] = {}),
                      r[e.key[12]].replace(e.q.parser, function(t, n, o) {
                        n && (r[e.q.name][n] = o);
                      }),
                      r
                    );
                  }
                })(t);
                return e
                  ? ('' === e.anchor && (e.source = e.source.replace('#', '')),
                    (t = e.source.replace('?' + e.query, '')))
                  : '(unknown)';
              },
              scrub: function(t, e) {
                var n = (function(t) {
                    for (var e, n = [], r = 0; r < t.length; ++r)
                      (e =
                        '^\\[?(%5[bB])?' +
                        t[r] +
                        '\\[?(%5[bB])?\\]?(%5[dD])?$'),
                        n.push(new RegExp(e, 'i'));
                    return n;
                  })((e = e || [])),
                  r = (function(t) {
                    for (var e, n = [], r = 0; r < t.length; ++r)
                      (e =
                        '\\[?(%5[bB])?' + t[r] + '\\[?(%5[bB])?\\]?(%5[dD])?'),
                        n.push(new RegExp('(' + e + '=)([^&\\n]+)', 'igm'));
                    return n;
                  })(e);
                function o(t, e) {
                  return e + '********';
                }
                return p(
                  t,
                  function t(e, i, s) {
                    var u = (function(t, e) {
                      var r;
                      for (r = 0; r < n.length; ++r)
                        if (n[r].test(t)) {
                          e = '********';
                          break;
                        }
                      return e;
                    })(e, i);
                    return u === i
                      ? a(i, 'object') || a(i, 'array')
                        ? p(i, t, s)
                        : (function(t) {
                            var e;
                            if (a(t, 'string'))
                              for (e = 0; e < r.length; ++e)
                                t = t.replace(r[e], o);
                            return t;
                          })(u)
                      : u;
                  },
                  [],
                );
              },
              set: function(t, e, n) {
                if (t) {
                  var r = e.split('.'),
                    o = r.length;
                  if (!(o < 1))
                    if (1 !== o)
                      try {
                        for (
                          var i = t[r[0]] || {}, a = i, s = 1;
                          s < o - 1;
                          ++s
                        )
                          (i[r[s]] = i[r[s]] || {}), (i = i[r[s]]);
                        (i[r[o - 1]] = n), (t[r[0]] = a);
                      } catch (t) {
                        return;
                      }
                    else t[r[0]] = n;
                }
              },
              stringify: h,
              traverse: p,
              typeName: s,
              uuid4: f,
            };
          },
          function(t, e, n) {
            n(17);
            var r = n(18),
              o = n(0);
            t.exports = {
              error: function() {
                var t = Array.prototype.slice.call(arguments, 0);
                t.unshift('Rollbar:'),
                  r.ieVersion() <= 8
                    ? console.error(o.formatArgsAsString(t))
                    : console.error.apply(console, t);
              },
              info: function() {
                var t = Array.prototype.slice.call(arguments, 0);
                t.unshift('Rollbar:'),
                  r.ieVersion() <= 8
                    ? console.info(o.formatArgsAsString(t))
                    : console.info.apply(console, t);
              },
              log: function() {
                var t = Array.prototype.slice.call(arguments, 0);
                t.unshift('Rollbar:'),
                  r.ieVersion() <= 8
                    ? console.log(o.formatArgsAsString(t))
                    : console.log.apply(console, t);
              },
            };
          },
          function(t, e, n) {
            var r = n(0);
            function o(t, e) {
              return [t, r.stringify(t, e)];
            }
            function i(t, e) {
              var n = t.length;
              return 2 * e < n ? t.slice(0, e).concat(t.slice(n - e)) : t;
            }
            function a(t, e, n) {
              n = void 0 === n ? 30 : n;
              var o,
                a = t.data.body;
              if (a.trace_chain)
                for (var s = a.trace_chain, u = 0; u < s.length; u++)
                  (o = i((o = s[u].frames), n)), (s[u].frames = o);
              else
                a.trace &&
                  ((o = i((o = a.trace.frames), n)), (a.trace.frames = o));
              return [t, r.stringify(t, e)];
            }
            function s(t, e) {
              return e && e.length > t ? e.slice(0, t - 3).concat('...') : e;
            }
            function u(t, e, n) {
              return [
                (e = r.traverse(
                  e,
                  function e(n, o, i) {
                    switch (r.typeName(o)) {
                      case 'string':
                        return s(t, o);
                      case 'object':
                      case 'array':
                        return r.traverse(o, e, i);
                      default:
                        return o;
                    }
                  },
                  [],
                )),
                r.stringify(e, n),
              ];
            }
            function c(t) {
              return (
                t.exception &&
                  (delete t.exception.description,
                  (t.exception.message = s(255, t.exception.message))),
                (t.frames = i(t.frames, 1)),
                t
              );
            }
            function l(t, e) {
              var n = t.data.body;
              if (n.trace_chain)
                for (var o = n.trace_chain, i = 0; i < o.length; i++)
                  o[i] = c(o[i]);
              else n.trace && (n.trace = c(n.trace));
              return [t, r.stringify(t, e)];
            }
            t.exports = {
              truncate: function(t, e, n) {
                n = void 0 === n ? 524288 : n;
                for (
                  var r,
                    i,
                    s,
                    c,
                    p = [
                      o,
                      a,
                      u.bind(null, 1024),
                      u.bind(null, 512),
                      u.bind(null, 256),
                      l,
                    ];
                  (r = p.shift());

                )
                  if (
                    ((t = (i = r(t, e))[0]),
                    (s = i[1]).error || ((c = n), !(s.value.length > c)))
                  )
                    return s;
                return s;
              },
              raw: o,
              truncateFrames: a,
              truncateStrings: u,
              maybeTruncateValue: s,
            };
          },
          function(t, e, n) {
            t.exports = {
              parse: function(t) {
                var e,
                  n,
                  r = {
                    protocol: null,
                    auth: null,
                    host: null,
                    path: null,
                    hash: null,
                    href: t,
                    hostname: null,
                    port: null,
                    pathname: null,
                    search: null,
                    query: null,
                  };
                if (
                  ((n =
                    -1 !== (e = t.indexOf('//'))
                      ? ((r.protocol = t.substring(0, e)), e + 2)
                      : 0),
                  -1 !== (e = t.indexOf('@', n)) &&
                    ((r.auth = t.substring(n, e)), (n = e + 1)),
                  -1 === (e = t.indexOf('/', n)))
                ) {
                  if (-1 === (e = t.indexOf('?', n)))
                    return (
                      -1 === (e = t.indexOf('#', n))
                        ? (r.host = t.substring(n))
                        : ((r.host = t.substring(n, e)),
                          (r.hash = t.substring(e))),
                      (r.hostname = r.host.split(':')[0]),
                      (r.port = r.host.split(':')[1]),
                      r.port && (r.port = parseInt(r.port, 10)),
                      r
                    );
                  (r.host = t.substring(n, e)),
                    (r.hostname = r.host.split(':')[0]),
                    (r.port = r.host.split(':')[1]),
                    r.port && (r.port = parseInt(r.port, 10)),
                    (n = e);
                } else
                  (r.host = t.substring(n, e)),
                    (r.hostname = r.host.split(':')[0]),
                    (r.port = r.host.split(':')[1]),
                    r.port && (r.port = parseInt(r.port, 10)),
                    (n = e);
                if (
                  (-1 === (e = t.indexOf('#', n))
                    ? (r.path = t.substring(n))
                    : ((r.path = t.substring(n, e)), (r.hash = t.substring(e))),
                  r.path)
                ) {
                  var o = r.path.split('?');
                  (r.pathname = o[0]),
                    (r.query = o[1]),
                    (r.search = r.query ? '?' + r.query : null);
                }
                return r;
              },
            };
          },
          function(t, e, n) {
            var r = n(22),
              o = new RegExp(
                '^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ',
              );
            function i(t) {
              var e = {};
              return (
                (e._stackFrame = t),
                (e.url = t.fileName),
                (e.line = t.lineNumber),
                (e.func = t.functionName),
                (e.column = t.columnNumber),
                (e.args = t.args),
                (e.context = null),
                e
              );
            }
            function a(t) {
              return {
                stack: (function() {
                  var e,
                    n = [];
                  if (t.stack) e = t;
                  else
                    try {
                      throw t;
                    } catch (o) {
                      e = o;
                    }
                  try {
                    n = r.parse(e);
                  } catch (o) {
                    n = [];
                  }
                  for (var o = [], a = 0; a < n.length; a++)
                    o.push(new i(n[a]));
                  return o;
                })(),
                message: t.message,
                name: (function(t) {
                  var e = t.name && t.name.length && t.name,
                    n =
                      t.constructor.name &&
                      t.constructor.name.length &&
                      t.constructor.name;
                  return e && n ? ('Error' !== e ? e : n) : e || n;
                })(t),
                rawStack: t.stack,
                rawException: t,
              };
            }
            t.exports = {
              guessFunctionName: function() {
                return '?';
              },
              guessErrorClass: function(t) {
                if (!t || !t.match)
                  return [
                    'Unknown error. There was no error message to display.',
                    '',
                  ];
                var e = t.match(o),
                  n = '(unknown)';
                return (
                  e &&
                    ((n = e[e.length - 1]),
                    (t = (t = t.replace(
                      (e[e.length - 2] || '') + n + ':',
                      '',
                    )).replace(/(^[\s]+|[\s]+$)/g, ''))),
                  [n, t]
                );
              },
              gatherContext: function() {
                return null;
              },
              parse: function(t) {
                var e = t;
                if (e.nested) {
                  for (var n = []; e; ) n.push(new a(e)), (e = e.nested);
                  return (n[0].traceChain = n)[0];
                }
                return new a(e);
              },
              Stack: a,
              Frame: i,
            };
          },
          function(t, e, n) {
            t.exports = n(6);
          },
          function(t, e, n) {
            var r = n(7),
              o = 'undefined' != typeof window && window._rollbarConfig,
              i = (o && o.globalAlias) || 'Rollbar',
              a =
                'undefined' != typeof window &&
                window[i] &&
                'function' == typeof window[i].shimId &&
                void 0 !== window[i].shimId();
            if (
              ('undefined' == typeof window ||
                window._rollbarStartTime ||
                (window._rollbarStartTime = new Date().getTime()),
              !a && o)
            ) {
              var s = new r(o);
              window[i] = s;
            } else
              'undefined' != typeof window
                ? ((window.rollbar = r), (window._rollbarDidLoad = !0))
                : 'undefined' != typeof self &&
                  ((self.rollbar = r), (self._rollbarDidLoad = !0));
            t.exports = r;
          },
          function(t, e, n) {
            var r = n(8),
              o = n(0),
              i = n(15),
              a = n(1),
              s = n(19),
              u = n(20),
              c = n(3),
              l = n(21),
              p = n(24),
              f = n(25),
              d = n(26),
              h = n(4),
              m = n(27);
            function g(t, e) {
              (this.options = o.handleOptions(_, t)),
                (this.options._configuredOptions = t);
              var n = new i(this.options, u, c);
              this.client = e || new r(this.options, n, a, 'browser');
              var s = w(),
                h = 'undefined' != typeof document && document;
              (this.isChrome = s.chrome && s.chrome.runtime),
                (this.anonymousErrorsPending = 0),
                (function(t, e) {
                  t.addTransform(l.handleDomException)
                    .addTransform(l.handleItemWithError)
                    .addTransform(l.ensureItemHasSomethingToSay)
                    .addTransform(l.addBaseInfo)
                    .addTransform(l.addRequestInfo(e))
                    .addTransform(l.addClientInfo(e))
                    .addTransform(l.addPluginInfo(e))
                    .addTransform(l.addBody)
                    .addTransform(p.addMessageWithError)
                    .addTransform(p.addTelemetryData)
                    .addTransform(p.addConfigToPayload)
                    .addTransform(l.scrubPayload)
                    .addTransform(p.userTransform(a))
                    .addTransform(p.addConfiguredOptions)
                    .addTransform(p.addDiagnosticKeys)
                    .addTransform(p.itemToPayload);
                })(this.client.notifier, s),
                (function(t) {
                  t.addPredicate(d.checkLevel)
                    .addPredicate(f.checkIgnore)
                    .addPredicate(d.userCheckIgnore(a))
                    .addPredicate(d.urlIsNotBlacklisted(a))
                    .addPredicate(d.urlIsWhitelisted(a))
                    .addPredicate(d.messageIsIgnored(a));
                })(this.client.queue),
                this.setupUnhandledCapture(),
                (this.instrumenter = new m(
                  this.options,
                  this.client.telemeter,
                  this,
                  s,
                  h,
                )),
                this.instrumenter.instrument();
            }
            var v = null;
            function y(t) {
              var e = 'Rollbar is not initialized';
              a.error(e), t && t(new Error(e));
            }
            function b(t) {
              for (var e = 0, n = t.length; e < n; ++e)
                if (o.isFunction(t[e])) return t[e];
            }
            function w() {
              return (
                ('undefined' != typeof window && window) ||
                ('undefined' != typeof self && self)
              );
            }
            (g.init = function(t, e) {
              return v ? v.global(t).configure(t) : (v = new g(t, e));
            }),
              (g.prototype.global = function(t) {
                return this.client.global(t), this;
              }),
              (g.global = function(t) {
                if (v) return v.global(t);
                y();
              }),
              (g.prototype.configure = function(t, e) {
                var n = this.options,
                  r = {};
                return (
                  e && (r = { payload: e }),
                  (this.options = o.handleOptions(n, t, r)),
                  (this.options._configuredOptions = o.handleOptions(
                    n._configuredOptions,
                    t,
                    r,
                  )),
                  this.client.configure(this.options, e),
                  this.instrumenter.configure(this.options),
                  this.setupUnhandledCapture(),
                  this
                );
              }),
              (g.configure = function(t, e) {
                if (v) return v.configure(t, e);
                y();
              }),
              (g.prototype.lastError = function() {
                return this.client.lastError;
              }),
              (g.lastError = function() {
                if (v) return v.lastError();
                y();
              }),
              (g.prototype.log = function() {
                var t = this._createItem(arguments),
                  e = t.uuid;
                return this.client.log(t), { uuid: e };
              }),
              (g.log = function() {
                if (v) return v.log.apply(v, arguments);
                y(b(arguments));
              }),
              (g.prototype.debug = function() {
                var t = this._createItem(arguments),
                  e = t.uuid;
                return this.client.debug(t), { uuid: e };
              }),
              (g.debug = function() {
                if (v) return v.debug.apply(v, arguments);
                y(b(arguments));
              }),
              (g.prototype.info = function() {
                var t = this._createItem(arguments),
                  e = t.uuid;
                return this.client.info(t), { uuid: e };
              }),
              (g.info = function() {
                if (v) return v.info.apply(v, arguments);
                y(b(arguments));
              }),
              (g.prototype.warn = function() {
                var t = this._createItem(arguments),
                  e = t.uuid;
                return this.client.warn(t), { uuid: e };
              }),
              (g.warn = function() {
                if (v) return v.warn.apply(v, arguments);
                y(b(arguments));
              }),
              (g.prototype.warning = function() {
                var t = this._createItem(arguments),
                  e = t.uuid;
                return this.client.warning(t), { uuid: e };
              }),
              (g.warning = function() {
                if (v) return v.warning.apply(v, arguments);
                y(b(arguments));
              }),
              (g.prototype.error = function() {
                var t = this._createItem(arguments),
                  e = t.uuid;
                return this.client.error(t), { uuid: e };
              }),
              (g.error = function() {
                if (v) return v.error.apply(v, arguments);
                y(b(arguments));
              }),
              (g.prototype.critical = function() {
                var t = this._createItem(arguments),
                  e = t.uuid;
                return this.client.critical(t), { uuid: e };
              }),
              (g.critical = function() {
                if (v) return v.critical.apply(v, arguments);
                y(b(arguments));
              }),
              (g.prototype.buildJsonPayload = function(t) {
                return this.client.buildJsonPayload(t);
              }),
              (g.buildJsonPayload = function() {
                if (v) return v.buildJsonPayload.apply(v, arguments);
                y();
              }),
              (g.prototype.sendJsonPayload = function(t) {
                return this.client.sendJsonPayload(t);
              }),
              (g.sendJsonPayload = function() {
                if (v) return v.sendJsonPayload.apply(v, arguments);
                y();
              }),
              (g.prototype.setupUnhandledCapture = function() {
                var t = w();
                this.unhandledExceptionsInitialized ||
                  ((this.options.captureUncaught ||
                    this.options.handleUncaughtExceptions) &&
                    (s.captureUncaughtExceptions(t, this),
                    this.options.wrapGlobalEventHandlers &&
                      s.wrapGlobals(t, this),
                    (this.unhandledExceptionsInitialized = !0))),
                  this.unhandledRejectionsInitialized ||
                    ((this.options.captureUnhandledRejections ||
                      this.options.handleUnhandledRejections) &&
                      (s.captureUnhandledRejections(t, this),
                      (this.unhandledRejectionsInitialized = !0)));
              }),
              (g.prototype.handleUncaughtException = function(
                t,
                e,
                n,
                r,
                i,
                a,
              ) {
                if (
                  this.options.captureUncaught ||
                  this.options.handleUncaughtExceptions
                ) {
                  if (
                    this.options.inspectAnonymousErrors &&
                    this.isChrome &&
                    null === i
                  )
                    return 'anonymous';
                  var s,
                    u = o.makeUnhandledStackInfo(
                      t,
                      e,
                      n,
                      r,
                      i,
                      'onerror',
                      'uncaught exception',
                      h,
                    );
                  o.isError(i)
                    ? ((s = this._createItem([
                        t,
                        i,
                        a,
                      ]))._unhandledStackInfo = u)
                    : o.isError(e)
                    ? ((s = this._createItem([
                        t,
                        e,
                        a,
                      ]))._unhandledStackInfo = u)
                    : ((s = this._createItem([t, a])).stackInfo = u),
                    (s.level = this.options.uncaughtErrorLevel),
                    (s._isUncaught = !0),
                    this.client.log(s);
                }
              }),
              (g.prototype.handleAnonymousErrors = function() {
                if (this.options.inspectAnonymousErrors && this.isChrome) {
                  var t = this;
                  try {
                    Error.prepareStackTrace = function(e, n) {
                      if (
                        t.options.inspectAnonymousErrors &&
                        t.anonymousErrorsPending
                      ) {
                        if (((t.anonymousErrorsPending -= 1), !e)) return;
                        (e._isAnonymous = !0),
                          t.handleUncaughtException(
                            e.message,
                            null,
                            null,
                            null,
                            e,
                          );
                      }
                      return e.stack;
                    };
                  } catch (t) {
                    (this.options.inspectAnonymousErrors = !1),
                      this.error('anonymous error handler failed', t);
                  }
                }
              }),
              (g.prototype.handleUnhandledRejection = function(t, e) {
                if (
                  this.options.captureUnhandledRejections ||
                  this.options.handleUnhandledRejections
                ) {
                  var n = 'unhandled rejection was null or undefined!';
                  if (t)
                    if (t.message) n = t.message;
                    else {
                      var r = o.stringify(t);
                      r.value && (n = r.value);
                    }
                  var i,
                    a = (t && t._rollbarContext) || (e && e._rollbarContext);
                  o.isError(t)
                    ? (i = this._createItem([n, t, a]))
                    : ((i = this._createItem([
                        n,
                        t,
                        a,
                      ])).stackInfo = o.makeUnhandledStackInfo(
                        n,
                        '',
                        0,
                        0,
                        null,
                        'unhandledrejection',
                        '',
                        h,
                      )),
                    (i.level = this.options.uncaughtErrorLevel),
                    (i._isUncaught = !0),
                    (i._originalArgs = i._originalArgs || []),
                    i._originalArgs.push(e),
                    this.client.log(i);
                }
              }),
              (g.prototype.wrap = function(t, e, n) {
                try {
                  var r;
                  if (
                    ((r = o.isFunction(e)
                      ? e
                      : function() {
                          return e || {};
                        }),
                    !o.isFunction(t))
                  )
                    return t;
                  if (t._isWrap) return t;
                  if (
                    !t._rollbar_wrapped &&
                    ((t._rollbar_wrapped = function() {
                      n && o.isFunction(n) && n.apply(this, arguments);
                      try {
                        return t.apply(this, arguments);
                      } catch (n) {
                        var e = n;
                        throw (e &&
                          window._rollbarWrappedError !== e &&
                          (o.isType(e, 'string') && (e = new String(e)),
                          (e._rollbarContext = r() || {}),
                          (e._rollbarContext._wrappedSource = t.toString()),
                          (window._rollbarWrappedError = e)),
                        e);
                      }
                    }),
                    (t._rollbar_wrapped._isWrap = !0),
                    t.hasOwnProperty)
                  )
                    for (var i in t)
                      t.hasOwnProperty(i) &&
                        '_rollbar_wrapped' !== i &&
                        (t._rollbar_wrapped[i] = t[i]);
                  return t._rollbar_wrapped;
                } catch (e) {
                  return t;
                }
              }),
              (g.wrap = function(t, e) {
                if (v) return v.wrap(t, e);
                y();
              }),
              (g.prototype.captureEvent = function() {
                var t = o.createTelemetryEvent(arguments);
                return this.client.captureEvent(t.type, t.metadata, t.level);
              }),
              (g.captureEvent = function() {
                if (v) return v.captureEvent.apply(v, arguments);
                y();
              }),
              (g.prototype.captureDomContentLoaded = function(t, e) {
                return (
                  e || (e = new Date()), this.client.captureDomContentLoaded(e)
                );
              }),
              (g.prototype.captureLoad = function(t, e) {
                return e || (e = new Date()), this.client.captureLoad(e);
              });
            var _ = {
              version: '2.14.4',
              scrubFields: [
                'pw',
                'pass',
                'passwd',
                'password',
                'secret',
                'confirm_password',
                'confirmPassword',
                'password_confirmation',
                'passwordConfirmation',
                'access_token',
                'accessToken',
                'X-Rollbar-Access-Token',
                'secret_key',
                'secretKey',
                'secretToken',
                'cc-number',
                'card number',
                'cardnumber',
                'cardnum',
                'ccnum',
                'ccnumber',
                'cc num',
                'creditcardnumber',
                'credit card number',
                'newcreditcardnumber',
                'new credit card',
                'creditcardno',
                'credit card no',
                'card#',
                'card #',
                'cc-csc',
                'cvc',
                'cvc2',
                'cvv2',
                'ccv2',
                'security code',
                'card verification',
                'name on credit card',
                'name on card',
                'nameoncard',
                'cardholder',
                'card holder',
                'name des karteninhabers',
                'ccname',
                'card type',
                'cardtype',
                'cc type',
                'cctype',
                'payment type',
                'expiration date',
                'expirationdate',
                'expdate',
                'cc-exp',
                'ccmonth',
                'ccyear',
              ],
              logLevel: 'debug',
              reportLevel: 'debug',
              uncaughtErrorLevel: 'error',
              endpoint: 'api.rollbar.com/api/1/item/',
              verbose: !(g.prototype._createItem = function(t) {
                return o.createItem(t, a, this);
              }),
              enabled: !0,
              transmit: !0,
              sendConfig: !1,
              includeItemsInTelemetry: !0,
              captureIp: !0,
              inspectAnonymousErrors: !0,
              ignoreDuplicateErrors: !0,
              wrapGlobalEventHandlers: !1,
            };
            t.exports = g;
          },
          function(t, e, n) {
            var r = n(9),
              o = n(12),
              i = n(13),
              a = n(14),
              s = n(0);
            function u(t, e, n, r) {
              (this.options = s.merge(t)),
                (this.logger = n),
                u.rateLimiter.configureGlobal(this.options),
                u.rateLimiter.setPlatformOptions(r, this.options),
                (this.api = e),
                (this.queue = new o(u.rateLimiter, e, n, this.options)),
                (this.notifier = new i(this.queue, this.options)),
                (this.telemeter = new a(this.options)),
                (this.lastError = null),
                (this.lastErrorHash = 'none');
            }
            (u.rateLimiter = new r({ maxItems: 0, itemsPerMinute: 60 })),
              (u.prototype.global = function(t) {
                return u.rateLimiter.configureGlobal(t), this;
              }),
              (u.prototype.configure = function(t, e) {
                var n = this.options,
                  r = {};
                return (
                  e && (r = { payload: e }),
                  (this.options = s.merge(n, t, r)),
                  this.notifier && this.notifier.configure(this.options),
                  this.telemeter && this.telemeter.configure(this.options),
                  this.global(this.options),
                  this
                );
              }),
              (u.prototype.log = function(t) {
                var e = this._defaultLogLevel();
                return this._log(e, t);
              }),
              (u.prototype.debug = function(t) {
                this._log('debug', t);
              }),
              (u.prototype.info = function(t) {
                this._log('info', t);
              }),
              (u.prototype.warn = function(t) {
                this._log('warning', t);
              }),
              (u.prototype.warning = function(t) {
                this._log('warning', t);
              }),
              (u.prototype.error = function(t) {
                this._log('error', t);
              }),
              (u.prototype.critical = function(t) {
                this._log('critical', t);
              }),
              (u.prototype.wait = function(t) {
                this.queue.wait(t);
              }),
              (u.prototype.captureEvent = function(t, e, n) {
                return this.telemeter.captureEvent(t, e, n);
              }),
              (u.prototype.captureDomContentLoaded = function(t) {
                return this.telemeter.captureDomContentLoaded(t);
              }),
              (u.prototype.captureLoad = function(t) {
                return this.telemeter.captureLoad(t);
              }),
              (u.prototype.buildJsonPayload = function(t) {
                return this.api.buildJsonPayload(t);
              }),
              (u.prototype.sendJsonPayload = function(t) {
                this.api.postJsonPayload(t);
              }),
              (u.prototype._log = function(t, e) {
                var n;
                if (
                  (e.callback && ((n = e.callback), delete e.callback),
                  this.options.ignoreDuplicateErrors &&
                    this._sameAsLastError(e))
                ) {
                  if (n) {
                    var r = new Error('ignored identical item');
                    (r.item = e), n(r);
                  }
                } else
                  try {
                    (e.level = e.level || t),
                      this.telemeter._captureRollbarItem(e),
                      (e.telemetryEvents = this.telemeter.copyEvents()),
                      this.notifier.log(e, n);
                  } catch (t) {
                    this.logger.error(t);
                  }
              }),
              (u.prototype._defaultLogLevel = function() {
                return this.options.logLevel || 'debug';
              }),
              (u.prototype._sameAsLastError = function(t) {
                if (!t._isUncaught) return !1;
                var e = (function(t) {
                  return (
                    (t.message || '') +
                    '::' +
                    ((t.err || {}).stack || String(t.err))
                  );
                })(t);
                return (
                  this.lastErrorHash === e ||
                  ((this.lastError = t.err), (this.lastErrorHash = e), !1)
                );
              }),
              (t.exports = u);
          },
          function(t, e, n) {
            var r = n(0);
            function o(t) {
              (this.startTime = r.now()),
                (this.counter = 0),
                (this.perMinCounter = 0),
                (this.platform = null),
                (this.platformOptions = {}),
                this.configureGlobal(t);
            }
            function i(t, e, n) {
              return !t.ignoreRateLimit && 1 <= e && e < n;
            }
            function a(t, e, n, r, o, i, a) {
              var s = null;
              return (
                n && (n = new Error(n)),
                n ||
                  r ||
                  (s = (function(t, e, n, r, o) {
                    var i = {
                      body: {
                        message: {
                          body: o
                            ? 'item per minute limit reached, ignoring errors until timeout'
                            : 'maxItems has been hit, ignoring errors until reset.',
                          extra: { maxItems: n, itemsPerMinute: r },
                        },
                      },
                      language: 'javascript',
                      environment:
                        e.environment || (e.payload && e.payload.environment),
                      notifier: {
                        version:
                          (e.notifier && e.notifier.version) || e.version,
                      },
                    };
                    return (
                      'browser' === t
                        ? ((i.platform = 'browser'),
                          (i.framework = 'browser-js'),
                          (i.notifier.name = 'rollbar-browser-js'))
                        : 'server' === t
                        ? ((i.framework = e.framework || 'node-js'),
                          (i.notifier.name = e.notifier.name))
                        : 'react-native' === t &&
                          ((i.framework = e.framework || 'react-native'),
                          (i.notifier.name = e.notifier.name)),
                      i
                    );
                  })(t, e, o, i, a)),
                { error: n, shouldSend: r, payload: s }
              );
            }
            (o.globalSettings = {
              startTime: r.now(),
              maxItems: void 0,
              itemsPerMinute: void 0,
            }),
              (o.prototype.configureGlobal = function(t) {
                void 0 !== t.startTime &&
                  (o.globalSettings.startTime = t.startTime),
                  void 0 !== t.maxItems &&
                    (o.globalSettings.maxItems = t.maxItems),
                  void 0 !== t.itemsPerMinute &&
                    (o.globalSettings.itemsPerMinute = t.itemsPerMinute);
              }),
              (o.prototype.shouldSend = function(t, e) {
                var n = (e = e || r.now()) - this.startTime;
                (n < 0 || 6e4 <= n) &&
                  ((this.startTime = e), (this.perMinCounter = 0));
                var s = o.globalSettings.maxItems,
                  u = o.globalSettings.itemsPerMinute;
                if (i(t, s, this.counter))
                  return a(
                    this.platform,
                    this.platformOptions,
                    s + ' max items reached',
                    !1,
                  );
                if (i(t, u, this.perMinCounter))
                  return a(
                    this.platform,
                    this.platformOptions,
                    u + ' items per minute reached',
                    !1,
                  );
                this.counter++, this.perMinCounter++;
                var c = !i(t, s, this.counter),
                  l = c;
                return (
                  (c = c && !i(t, u, this.perMinCounter)),
                  a(this.platform, this.platformOptions, null, c, s, u, l)
                );
              }),
              (o.prototype.setPlatformOptions = function(t, e) {
                (this.platform = t), (this.platformOptions = e);
              }),
              (t.exports = o);
          },
          function(t, e, n) {
            var r = Object.prototype.hasOwnProperty,
              o = Object.prototype.toString,
              i = function(t) {
                if (!t || '[object Object]' !== o.call(t)) return !1;
                var e,
                  n = r.call(t, 'constructor'),
                  i =
                    t.constructor &&
                    t.constructor.prototype &&
                    r.call(t.constructor.prototype, 'isPrototypeOf');
                if (t.constructor && !n && !i) return !1;
                for (e in t);
                return void 0 === e || r.call(t, e);
              };
            t.exports = function t() {
              var e,
                n,
                r,
                o,
                a,
                s = {},
                u = null,
                c = arguments.length;
              for (e = 0; e < c; e++)
                if (null != (u = arguments[e]))
                  for (a in u)
                    (n = s[a]),
                      s !== (r = u[a]) &&
                        (r && i(r)
                          ? ((o = n && i(n) ? n : {}), (s[a] = t(o, r)))
                          : void 0 !== r && (s[a] = r));
              return s;
            };
          },
          function(t, e) {
            t.exports = function(t) {
              var e,
                n,
                r,
                o,
                i,
                a,
                s,
                u,
                c,
                l,
                p,
                f,
                d,
                h = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
              function m(t) {
                return t < 10 ? '0' + t : t;
              }
              function g() {
                return this.valueOf();
              }
              function v(t) {
                return (
                  (h.lastIndex = 0),
                  h.test(t)
                    ? '"' +
                      t.replace(h, function(t) {
                        var e = r[t];
                        return 'string' == typeof e
                          ? e
                          : '\\u' +
                              ('0000' + t.charCodeAt(0).toString(16)).slice(-4);
                      }) +
                      '"'
                    : '"' + t + '"'
                );
              }
              'function' != typeof Date.prototype.toJSON &&
                ((Date.prototype.toJSON = function() {
                  return isFinite(this.valueOf())
                    ? this.getUTCFullYear() +
                        '-' +
                        m(this.getUTCMonth() + 1) +
                        '-' +
                        m(this.getUTCDate()) +
                        'T' +
                        m(this.getUTCHours()) +
                        ':' +
                        m(this.getUTCMinutes()) +
                        ':' +
                        m(this.getUTCSeconds()) +
                        'Z'
                    : null;
                }),
                (Boolean.prototype.toJSON = g),
                (Number.prototype.toJSON = g),
                (String.prototype.toJSON = g)),
                'function' != typeof t.stringify &&
                  ((r = {
                    '\b': '\\b',
                    '\t': '\\t',
                    '\n': '\\n',
                    '\f': '\\f',
                    '\r': '\\r',
                    '"': '\\"',
                    '\\': '\\\\',
                  }),
                  (t.stringify = function(t, r, i) {
                    var a;
                    if (((n = e = ''), 'number' == typeof i))
                      for (a = 0; a < i; a += 1) n += ' ';
                    else 'string' == typeof i && (n = i);
                    if (
                      (o = r) &&
                      'function' != typeof r &&
                      ('object' != typeof r || 'number' != typeof r.length)
                    )
                      throw new Error('JSON.stringify');
                    return (function t(r, i) {
                      var a,
                        s,
                        u,
                        c,
                        l,
                        p = e,
                        f = i[r];
                      switch (
                        (f &&
                          'object' == typeof f &&
                          'function' == typeof f.toJSON &&
                          (f = f.toJSON(r)),
                        'function' == typeof o && (f = o.call(i, r, f)),
                        typeof f)
                      ) {
                        case 'string':
                          return v(f);
                        case 'number':
                          return isFinite(f) ? String(f) : 'null';
                        case 'boolean':
                        case 'null':
                          return String(f);
                        case 'object':
                          if (!f) return 'null';
                          if (
                            ((e += n),
                            (l = []),
                            '[object Array]' ===
                              Object.prototype.toString.apply(f))
                          ) {
                            for (c = f.length, a = 0; a < c; a += 1)
                              l[a] = t(a, f) || 'null';
                            return (
                              (u =
                                0 === l.length
                                  ? '[]'
                                  : e
                                  ? '[\n' +
                                    e +
                                    l.join(',\n' + e) +
                                    '\n' +
                                    p +
                                    ']'
                                  : '[' + l.join(',') + ']'),
                              (e = p),
                              u
                            );
                          }
                          if (o && 'object' == typeof o)
                            for (c = o.length, a = 0; a < c; a += 1)
                              'string' != typeof o[a] ||
                                ((u = t((s = o[a]), f)) &&
                                  l.push(v(s) + (e ? ': ' : ':') + u));
                          else
                            for (s in f)
                              !Object.prototype.hasOwnProperty.call(f, s) ||
                                ((u = t(s, f)) &&
                                  l.push(v(s) + (e ? ': ' : ':') + u));
                          return (
                            (u =
                              0 === l.length
                                ? '{}'
                                : e
                                ? '{\n' + e + l.join(',\n' + e) + '\n' + p + '}'
                                : '{' + l.join(',') + '}'),
                            (e = p),
                            u
                          );
                      }
                    })('', { '': t });
                  })),
                'function' != typeof t.parse &&
                  (t.parse =
                    ((l = {
                      '\\': '\\',
                      '"': '"',
                      '/': '/',
                      t: '\t',
                      n: '\n',
                      r: '\r',
                      f: '\f',
                      b: '\b',
                    }),
                    (p = {
                      go: function() {
                        i = 'ok';
                      },
                      firstokey: function() {
                        (u = c), (i = 'colon');
                      },
                      okey: function() {
                        (u = c), (i = 'colon');
                      },
                      ovalue: function() {
                        i = 'ocomma';
                      },
                      firstavalue: function() {
                        i = 'acomma';
                      },
                      avalue: function() {
                        i = 'acomma';
                      },
                    }),
                    (f = {
                      go: function() {
                        i = 'ok';
                      },
                      ovalue: function() {
                        i = 'ocomma';
                      },
                      firstavalue: function() {
                        i = 'acomma';
                      },
                      avalue: function() {
                        i = 'acomma';
                      },
                    }),
                    (d = {
                      '{': {
                        go: function() {
                          a.push({ state: 'ok' }), (s = {}), (i = 'firstokey');
                        },
                        ovalue: function() {
                          a.push({ container: s, state: 'ocomma', key: u }),
                            (s = {}),
                            (i = 'firstokey');
                        },
                        firstavalue: function() {
                          a.push({ container: s, state: 'acomma' }),
                            (s = {}),
                            (i = 'firstokey');
                        },
                        avalue: function() {
                          a.push({ container: s, state: 'acomma' }),
                            (s = {}),
                            (i = 'firstokey');
                        },
                      },
                      '}': {
                        firstokey: function() {
                          var t = a.pop();
                          (c = s),
                            (s = t.container),
                            (u = t.key),
                            (i = t.state);
                        },
                        ocomma: function() {
                          var t = a.pop();
                          (s[u] = c),
                            (c = s),
                            (s = t.container),
                            (u = t.key),
                            (i = t.state);
                        },
                      },
                      '[': {
                        go: function() {
                          a.push({ state: 'ok' }),
                            (s = []),
                            (i = 'firstavalue');
                        },
                        ovalue: function() {
                          a.push({ container: s, state: 'ocomma', key: u }),
                            (s = []),
                            (i = 'firstavalue');
                        },
                        firstavalue: function() {
                          a.push({ container: s, state: 'acomma' }),
                            (s = []),
                            (i = 'firstavalue');
                        },
                        avalue: function() {
                          a.push({ container: s, state: 'acomma' }),
                            (s = []),
                            (i = 'firstavalue');
                        },
                      },
                      ']': {
                        firstavalue: function() {
                          var t = a.pop();
                          (c = s),
                            (s = t.container),
                            (u = t.key),
                            (i = t.state);
                        },
                        acomma: function() {
                          var t = a.pop();
                          s.push(c),
                            (c = s),
                            (s = t.container),
                            (u = t.key),
                            (i = t.state);
                        },
                      },
                      ':': {
                        colon: function() {
                          if (Object.hasOwnProperty.call(s, u))
                            throw new SyntaxError("Duplicate key '" + u + '"');
                          i = 'ovalue';
                        },
                      },
                      ',': {
                        ocomma: function() {
                          (s[u] = c), (i = 'okey');
                        },
                        acomma: function() {
                          s.push(c), (i = 'avalue');
                        },
                      },
                      true: {
                        go: function() {
                          (c = !0), (i = 'ok');
                        },
                        ovalue: function() {
                          (c = !0), (i = 'ocomma');
                        },
                        firstavalue: function() {
                          (c = !0), (i = 'acomma');
                        },
                        avalue: function() {
                          (c = !0), (i = 'acomma');
                        },
                      },
                      false: {
                        go: function() {
                          (c = !1), (i = 'ok');
                        },
                        ovalue: function() {
                          (c = !1), (i = 'ocomma');
                        },
                        firstavalue: function() {
                          (c = !1), (i = 'acomma');
                        },
                        avalue: function() {
                          (c = !1), (i = 'acomma');
                        },
                      },
                      null: {
                        go: function() {
                          (c = null), (i = 'ok');
                        },
                        ovalue: function() {
                          (c = null), (i = 'ocomma');
                        },
                        firstavalue: function() {
                          (c = null), (i = 'acomma');
                        },
                        avalue: function() {
                          (c = null), (i = 'acomma');
                        },
                      },
                    }),
                    function(t, e) {
                      var n,
                        r,
                        o = /^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;
                      (i = 'go'), (a = []);
                      try {
                        for (; (n = o.exec(t)); )
                          n[1]
                            ? d[n[1]][i]()
                            : n[2]
                            ? ((c = +n[2]), f[i]())
                            : ((r = n[3]),
                              (c = r.replace(/\\(?:u(.{4})|([^u]))/g, function(
                                t,
                                e,
                                n,
                              ) {
                                return e
                                  ? String.fromCharCode(parseInt(e, 16))
                                  : l[n];
                              })),
                              p[i]()),
                            (t = t.slice(n[0].length));
                      } catch (t) {
                        i = t;
                      }
                      if ('ok' !== i || /[^\u0020\t\n\r]/.test(t))
                        throw i instanceof SyntaxError
                          ? i
                          : new SyntaxError('JSON');
                      return 'function' == typeof e
                        ? (function t(n, r) {
                            var o,
                              i,
                              a = n[r];
                            if (a && 'object' == typeof a)
                              for (o in c)
                                Object.prototype.hasOwnProperty.call(a, o) &&
                                  (void 0 !== (i = t(a, o))
                                    ? (a[o] = i)
                                    : delete a[o]);
                            return e.call(n, r, a);
                          })({ '': c }, '')
                        : c;
                    }));
            };
          },
          function(t, e, n) {
            var r = n(0);
            function o(t, e, n, r) {
              (this.rateLimiter = t),
                (this.api = e),
                (this.logger = n),
                (this.options = r),
                (this.predicates = []),
                (this.pendingItems = []),
                (this.pendingRequests = []),
                (this.retryQueue = []),
                (this.retryHandle = null),
                (this.waitCallback = null),
                (this.waitIntervalID = null);
            }
            (o.prototype.configure = function(t) {
              this.api && this.api.configure(t);
              var e = this.options;
              return (this.options = r.merge(e, t)), this;
            }),
              (o.prototype.addPredicate = function(t) {
                return r.isFunction(t) && this.predicates.push(t), this;
              }),
              (o.prototype.addPendingItem = function(t) {
                this.pendingItems.push(t);
              }),
              (o.prototype.removePendingItem = function(t) {
                var e = this.pendingItems.indexOf(t);
                -1 !== e && this.pendingItems.splice(e, 1);
              }),
              (o.prototype.addItem = function(t, e, n, o) {
                (e && r.isFunction(e)) || (e = function() {});
                var i = this._applyPredicates(t);
                if (i.stop) return this.removePendingItem(o), void e(i.err);
                if (
                  (this._maybeLog(t, n),
                  this.removePendingItem(o),
                  this.options.transmit)
                ) {
                  this.pendingRequests.push(t);
                  try {
                    this._makeApiRequest(
                      t,
                      function(n, r) {
                        this._dequeuePendingRequest(t), e(n, r);
                      }.bind(this),
                    );
                  } catch (n) {
                    this._dequeuePendingRequest(t), e(n);
                  }
                } else e(new Error('Transmit disabled'));
              }),
              (o.prototype.wait = function(t) {
                r.isFunction(t) &&
                  ((this.waitCallback = t),
                  this._maybeCallWait() ||
                    (this.waitIntervalID &&
                      (this.waitIntervalID = clearInterval(
                        this.waitIntervalID,
                      )),
                    (this.waitIntervalID = setInterval(
                      function() {
                        this._maybeCallWait();
                      }.bind(this),
                      500,
                    ))));
              }),
              (o.prototype._applyPredicates = function(t) {
                for (
                  var e = null, n = 0, r = this.predicates.length;
                  n < r;
                  n++
                )
                  if (
                    !(e = this.predicates[n](t, this.options)) ||
                    void 0 !== e.err
                  )
                    return { stop: !0, err: e.err };
                return { stop: !1, err: null };
              }),
              (o.prototype._makeApiRequest = function(t, e) {
                var n = this.rateLimiter.shouldSend(t);
                n.shouldSend
                  ? this.api.postItem(
                      t,
                      function(n, r) {
                        n ? this._maybeRetry(n, t, e) : e(n, r);
                      }.bind(this),
                    )
                  : n.error
                  ? e(n.error)
                  : this.api.postItem(n.payload, e);
              });
            var i = [
              'ECONNRESET',
              'ENOTFOUND',
              'ESOCKETTIMEDOUT',
              'ETIMEDOUT',
              'ECONNREFUSED',
              'EHOSTUNREACH',
              'EPIPE',
              'EAI_AGAIN',
            ];
            (o.prototype._maybeRetry = function(t, e, n) {
              var r = !1;
              if (this.options.retryInterval)
                for (var o = 0, a = i.length; o < a; o++)
                  if (t.code === i[o]) {
                    r = !0;
                    break;
                  }
              r ? this._retryApiRequest(e, n) : n(t);
            }),
              (o.prototype._retryApiRequest = function(t, e) {
                this.retryQueue.push({ item: t, callback: e }),
                  this.retryHandle ||
                    (this.retryHandle = setInterval(
                      function() {
                        for (; this.retryQueue.length; ) {
                          var t = this.retryQueue.shift();
                          this._makeApiRequest(t.item, t.callback);
                        }
                      }.bind(this),
                      this.options.retryInterval,
                    ));
              }),
              (o.prototype._dequeuePendingRequest = function(t) {
                var e = this.pendingRequests.indexOf(t);
                -1 !== e &&
                  (this.pendingRequests.splice(e, 1), this._maybeCallWait());
              }),
              (o.prototype._maybeLog = function(t, e) {
                if (this.logger && this.options.verbose) {
                  var n = e;
                  if (
                    (n =
                      (n = n || r.get(t, 'body.trace.exception.message')) ||
                      r.get(t, 'body.trace_chain.0.exception.message'))
                  )
                    return void this.logger.error(n);
                  (n = r.get(t, 'body.message.body')) && this.logger.log(n);
                }
              }),
              (o.prototype._maybeCallWait = function() {
                return !(
                  !r.isFunction(this.waitCallback) ||
                  0 !== this.pendingItems.length ||
                  0 !== this.pendingRequests.length ||
                  (this.waitIntervalID &&
                    (this.waitIntervalID = clearInterval(this.waitIntervalID)),
                  this.waitCallback(),
                  0)
                );
              }),
              (t.exports = o);
          },
          function(t, e, n) {
            var r = n(0);
            function o(t, e) {
              (this.queue = t),
                (this.options = e),
                (this.transforms = []),
                (this.diagnostic = {});
            }
            (o.prototype.configure = function(t) {
              this.queue && this.queue.configure(t);
              var e = this.options;
              return (this.options = r.merge(e, t)), this;
            }),
              (o.prototype.addTransform = function(t) {
                return r.isFunction(t) && this.transforms.push(t), this;
              }),
              (o.prototype.log = function(t, e) {
                if (
                  ((e && r.isFunction(e)) || (e = function() {}),
                  !this.options.enabled)
                )
                  return e(new Error('Rollbar is not enabled'));
                this.queue.addPendingItem(t);
                var n = t.err;
                this._applyTransforms(
                  t,
                  function(r, o) {
                    if (r) return this.queue.removePendingItem(t), e(r, null);
                    this.queue.addItem(o, e, n, t);
                  }.bind(this),
                );
              }),
              (o.prototype._applyTransforms = function(t, e) {
                var n = -1,
                  r = this.transforms.length,
                  o = this.transforms,
                  i = this.options,
                  a = function(t, s) {
                    t ? e(t, null) : ++n !== r ? o[n](s, i, a) : e(null, s);
                  };
                a(null, t);
              }),
              (t.exports = o);
          },
          function(t, e, n) {
            var r = n(0);
            function o(t) {
              (this.queue = []), (this.options = r.merge(t));
              var e = this.options.maxTelemetryEvents || 100;
              this.maxQueueSize = Math.max(0, Math.min(e, 100));
            }
            (o.prototype.configure = function(t) {
              var e = this.options;
              this.options = r.merge(e, t);
              var n = this.options.maxTelemetryEvents || 100,
                o = Math.max(0, Math.min(n, 100)),
                i = 0;
              this.maxQueueSize > o && (i = this.maxQueueSize - o),
                (this.maxQueueSize = o),
                this.queue.splice(0, i);
            }),
              (o.prototype.copyEvents = function() {
                var t = Array.prototype.slice.call(this.queue, 0);
                if (r.isFunction(this.options.filterTelemetry))
                  try {
                    for (var e = t.length; e--; )
                      this.options.filterTelemetry(t[e]) && t.splice(e, 1);
                  } catch (t) {
                    this.options.filterTelemetry = null;
                  }
                return t;
              }),
              (o.prototype.capture = function(t, e, n, o, i) {
                var a = {
                  level: (function(t, e) {
                    return e || { error: 'error', manual: 'info' }[t] || 'info';
                  })(t, n),
                  type: t,
                  timestamp_ms: i || r.now(),
                  body: e,
                  source: 'client',
                };
                o && (a.uuid = o);
                try {
                  if (
                    r.isFunction(this.options.filterTelemetry) &&
                    this.options.filterTelemetry(a)
                  )
                    return !1;
                } catch (t) {
                  this.options.filterTelemetry = null;
                }
                return this.push(a), a;
              }),
              (o.prototype.captureEvent = function(t, e, n, r) {
                return this.capture(t, e, n, r);
              }),
              (o.prototype.captureError = function(t, e, n, r) {
                var o = { message: t.message || String(t) };
                return (
                  t.stack && (o.stack = t.stack),
                  this.capture('error', o, e, n, r)
                );
              }),
              (o.prototype.captureLog = function(t, e, n, r) {
                return this.capture('log', { message: t }, e, n, r);
              }),
              (o.prototype.captureNetwork = function(t, e, n, r) {
                (e = e || 'xhr'),
                  (t.subtype = t.subtype || e),
                  r && (t.request = r);
                var o = this.levelFromStatus(t.status_code);
                return this.capture('network', t, o, n);
              }),
              (o.prototype.levelFromStatus = function(t) {
                return 200 <= t && t < 400
                  ? 'info'
                  : 0 === t || 400 <= t
                  ? 'error'
                  : 'info';
              }),
              (o.prototype.captureDom = function(t, e, n, r, o) {
                var i = { subtype: t, element: e };
                return (
                  void 0 !== n && (i.value = n),
                  void 0 !== r && (i.checked = r),
                  this.capture('dom', i, 'info', o)
                );
              }),
              (o.prototype.captureNavigation = function(t, e, n) {
                return this.capture(
                  'navigation',
                  { from: t, to: e },
                  'info',
                  n,
                );
              }),
              (o.prototype.captureDomContentLoaded = function(t) {
                return this.capture(
                  'navigation',
                  { subtype: 'DOMContentLoaded' },
                  'info',
                  void 0,
                  t && t.getTime(),
                );
              }),
              (o.prototype.captureLoad = function(t) {
                return this.capture(
                  'navigation',
                  { subtype: 'load' },
                  'info',
                  void 0,
                  t && t.getTime(),
                );
              }),
              (o.prototype.captureConnectivityChange = function(t, e) {
                return this.captureNetwork({ change: t }, 'connectivity', e);
              }),
              (o.prototype._captureRollbarItem = function(t) {
                if (this.options.includeItemsInTelemetry)
                  return t.err
                    ? this.captureError(t.err, t.level, t.uuid, t.timestamp)
                    : t.message
                    ? this.captureLog(t.message, t.level, t.uuid, t.timestamp)
                    : t.custom
                    ? this.capture(
                        'log',
                        t.custom,
                        t.level,
                        t.uuid,
                        t.timestamp,
                      )
                    : void 0;
              }),
              (o.prototype.push = function(t) {
                this.queue.push(t),
                  this.queue.length > this.maxQueueSize && this.queue.shift();
              }),
              (t.exports = o);
          },
          function(t, e, n) {
            var r = n(0),
              o = n(16),
              i = n(2),
              a = {
                hostname: 'api.rollbar.com',
                path: '/api/1/item/',
                search: null,
                version: '1',
                protocol: 'https:',
                port: 443,
              };
            function s(t, e, n, r) {
              (this.options = t),
                (this.transport = e),
                (this.url = n),
                (this.jsonBackup = r),
                (this.accessToken = t.accessToken),
                (this.transportOptions = u(t, n));
            }
            function u(t, e) {
              return o.getTransportFromOptions(t, a, e);
            }
            (s.prototype.postItem = function(t, e) {
              var n = o.transportOptions(this.transportOptions, 'POST'),
                r = o.buildPayload(this.accessToken, t, this.jsonBackup);
              this.transport.post(this.accessToken, n, r, e);
            }),
              (s.prototype.buildJsonPayload = function(t, e) {
                var n = o.buildPayload(this.accessToken, t, this.jsonBackup),
                  r = i.truncate(n);
                return r.error ? (e && e(r.error), null) : r.value;
              }),
              (s.prototype.postJsonPayload = function(t, e) {
                var n = o.transportOptions(this.transportOptions, 'POST');
                this.transport.postJsonPayload(this.accessToken, n, t, e);
              }),
              (s.prototype.configure = function(t) {
                var e = this.oldOptions;
                return (
                  (this.options = r.merge(e, t)),
                  (this.transportOptions = u(this.options, this.url)),
                  void 0 !== this.options.accessToken &&
                    (this.accessToken = this.options.accessToken),
                  this
                );
              }),
              (t.exports = s);
          },
          function(t, e, n) {
            var r = n(0);
            t.exports = {
              buildPayload: function(t, e, n) {
                if (!r.isType(e.context, 'string')) {
                  var o = r.stringify(e.context, n);
                  o.error
                    ? (e.context = "Error: could not serialize 'context'")
                    : (e.context = o.value || ''),
                    255 < e.context.length &&
                      (e.context = e.context.substr(0, 255));
                }
                return { access_token: t, data: e };
              },
              getTransportFromOptions: function(t, e, n) {
                var r = e.hostname,
                  o = e.protocol,
                  i = e.port,
                  a = e.path,
                  s = e.search,
                  u = t.proxy;
                if (t.endpoint) {
                  var c = n.parse(t.endpoint);
                  (r = c.hostname),
                    (o = c.protocol),
                    (i = c.port),
                    (a = c.pathname),
                    (s = c.search);
                }
                return {
                  hostname: r,
                  protocol: o,
                  port: i,
                  path: a,
                  search: s,
                  proxy: u,
                };
              },
              transportOptions: function(t, e) {
                var n = t.protocol || 'https:',
                  r =
                    t.port ||
                    ('http:' === n ? 80 : 'https:' === n ? 443 : void 0),
                  o = t.hostname,
                  i = t.path;
                return (
                  t.search && (i += t.search),
                  t.proxy &&
                    ((i = n + '//' + o + i),
                    (o = t.proxy.host || t.proxy.hostname),
                    (r = t.proxy.port),
                    (n = t.proxy.protocol || n)),
                  { protocol: n, hostname: o, path: i, port: r, method: e }
                );
              },
              appendPathToPath: function(t, e) {
                var n = /\/$/.test(t),
                  r = /^\//.test(e);
                return (
                  n && r ? (e = e.substring(1)) : n || r || (e = '/' + e), t + e
                );
              },
            };
          },
          function(t, e) {
            !(function(t) {
              t.console || (t.console = {});
              for (
                var e,
                  n,
                  r = t.console,
                  o = function() {},
                  i = ['memory'],
                  a = 'assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn'.split(
                    ',',
                  );
                (e = i.pop());

              )
                r[e] || (r[e] = {});
              for (; (n = a.pop()); ) r[n] || (r[n] = o);
            })('undefined' == typeof window ? this : window);
          },
          function(t, e, n) {
            var r = {
              ieVersion: function() {
                if ('undefined' != typeof document) {
                  for (
                    var t = 3,
                      e = document.createElement('div'),
                      n = e.getElementsByTagName('i');
                    (e.innerHTML =
                      '\x3c!--[if gt IE ' + ++t + ']><i></i><![endif]--\x3e'),
                      n[0];

                  );
                  return 4 < t ? t : void 0;
                }
              },
            };
            t.exports = r;
          },
          function(t, e, n) {
            function r(t, e, n) {
              if (e.hasOwnProperty && e.hasOwnProperty('addEventListener')) {
                for (
                  var r = e.addEventListener;
                  r._rollbarOldAdd && r.belongsToShim;

                )
                  r = r._rollbarOldAdd;
                var o = function(e, n, o) {
                  r.call(this, e, t.wrap(n), o);
                };
                (o._rollbarOldAdd = r),
                  (o.belongsToShim = n),
                  (e.addEventListener = o);
                for (
                  var i = e.removeEventListener;
                  i._rollbarOldRemove && i.belongsToShim;

                )
                  i = i._rollbarOldRemove;
                var a = function(t, e, n) {
                  i.call(this, t, (e && e._rollbar_wrapped) || e, n);
                };
                (a._rollbarOldRemove = i),
                  (a.belongsToShim = n),
                  (e.removeEventListener = a);
              }
            }
            t.exports = {
              captureUncaughtExceptions: function(t, e, n) {
                if (t) {
                  var r;
                  if ('function' == typeof e._rollbarOldOnError)
                    r = e._rollbarOldOnError;
                  else if (t.onerror) {
                    for (r = t.onerror; r._rollbarOldOnError; )
                      r = r._rollbarOldOnError;
                    e._rollbarOldOnError = r;
                  }
                  e.handleAnonymousErrors();
                  var o = function() {
                    var n = Array.prototype.slice.call(arguments, 0);
                    !(function(t, e, n, r) {
                      t._rollbarWrappedError &&
                        (r[4] || (r[4] = t._rollbarWrappedError),
                        r[5] || (r[5] = t._rollbarWrappedError._rollbarContext),
                        (t._rollbarWrappedError = null));
                      var o = e.handleUncaughtException.apply(e, r);
                      n && n.apply(t, r),
                        'anonymous' === o && (e.anonymousErrorsPending += 1);
                    })(t, e, r, n);
                  };
                  n && (o._rollbarOldOnError = r), (t.onerror = o);
                }
              },
              captureUnhandledRejections: function(t, e, n) {
                if (t) {
                  'function' == typeof t._rollbarURH &&
                    t._rollbarURH.belongsToShim &&
                    t.removeEventListener('unhandledrejection', t._rollbarURH);
                  var r = function(t) {
                    var n, r, o;
                    try {
                      n = t.reason;
                    } catch (t) {
                      n = void 0;
                    }
                    try {
                      r = t.promise;
                    } catch (t) {
                      r =
                        '[unhandledrejection] error getting `promise` from event';
                    }
                    try {
                      (o = t.detail),
                        !n && o && ((n = o.reason), (r = o.promise));
                    } catch (t) {}
                    n ||
                      (n =
                        '[unhandledrejection] error getting `reason` from event'),
                      e &&
                        e.handleUnhandledRejection &&
                        e.handleUnhandledRejection(n, r);
                  };
                  (r.belongsToShim = n),
                    (t._rollbarURH = r),
                    t.addEventListener('unhandledrejection', r);
                }
              },
              wrapGlobals: function(t, e, n) {
                if (t) {
                  var o,
                    i,
                    a = 'EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload'.split(
                      ',',
                    );
                  for (o = 0; o < a.length; ++o)
                    t[(i = a[o])] && t[i].prototype && r(e, t[i].prototype, n);
                }
              },
            };
          },
          function(t, e, n) {
            var r = n(0),
              o = n(2),
              i = n(1);
            function a(t, e, n, r, o, i) {
              var a =
                  ('undefined' != typeof window && window) ||
                  ('undefined' != typeof self && self),
                u = a && a.Zone && a.Zone.current;
              u && 'angular' === u._name
                ? u._parent.run(function() {
                    s(t, e, n, r, o, i);
                  })
                : s(t, e, n, r, o, i);
            }
            function s(t, e, n, o, a, s) {
              if ('undefined' != typeof RollbarProxy)
                return (function(t, e) {
                  new RollbarProxy().sendJsonPayload(
                    t,
                    function(t) {},
                    function(t) {
                      e(new Error(t));
                    },
                  );
                })(o, a);
              var c;
              if (
                !(c = s
                  ? s()
                  : (function() {
                      var t,
                        e,
                        n = [
                          function() {
                            return new XMLHttpRequest();
                          },
                          function() {
                            return new ActiveXObject('Msxml2.XMLHTTP');
                          },
                          function() {
                            return new ActiveXObject('Msxml3.XMLHTTP');
                          },
                          function() {
                            return new ActiveXObject('Microsoft.XMLHTTP');
                          },
                        ],
                        r = n.length;
                      for (e = 0; e < r; e++)
                        try {
                          t = n[e]();
                          break;
                        } catch (t) {}
                      return t;
                    })())
              )
                return a(new Error('No way to send a request'));
              try {
                try {
                  var l = function() {
                    try {
                      if (l && 4 === c.readyState) {
                        l = void 0;
                        var t = r.jsonParse(c.responseText);
                        if (
                          (function(t) {
                            return t && t.status && 200 === t.status;
                          })(c)
                        )
                          return void a(t.error, t.value);
                        if (
                          (function(t) {
                            return (
                              t &&
                              r.isType(t.status, 'number') &&
                              400 <= t.status &&
                              t.status < 600
                            );
                          })(c)
                        ) {
                          if (403 === c.status) {
                            var e = t.value && t.value.message;
                            i.error(e);
                          }
                          a(new Error(String(c.status)));
                        } else
                          a(
                            u(
                              'XHR response had no status code (likely connection failure)',
                            ),
                          );
                      }
                    } catch (t) {
                      var n;
                      (n = t && t.stack ? t : new Error(t)), a(n);
                    }
                  };
                  c.open(n, e, !0),
                    c.setRequestHeader &&
                      (c.setRequestHeader('Content-Type', 'application/json'),
                      c.setRequestHeader('X-Rollbar-Access-Token', t)),
                    (c.onreadystatechange = l),
                    c.send(o);
                } catch (t) {
                  if ('undefined' != typeof XDomainRequest) {
                    if (!window || !window.location)
                      return a(
                        new Error(
                          'No window available during request, unknown environment',
                        ),
                      );
                    'http:' === window.location.href.substring(0, 5) &&
                      'https' === e.substring(0, 5) &&
                      (e = 'http' + e.substring(5));
                    var p = new XDomainRequest();
                    (p.onprogress = function() {}),
                      (p.ontimeout = function() {
                        a(u('Request timed out', 'ETIMEDOUT'));
                      }),
                      (p.onerror = function() {
                        a(new Error('Error during request'));
                      }),
                      (p.onload = function() {
                        var t = r.jsonParse(p.responseText);
                        a(t.error, t.value);
                      }),
                      p.open(n, e, !0),
                      p.send(o);
                  } else
                    a(new Error('Cannot find a method to transport a request'));
                }
              } catch (t) {
                a(t);
              }
            }
            function u(t, e) {
              var n = new Error(t);
              return (n.code = e || 'ENOTFOUND'), n;
            }
            t.exports = {
              get: function(t, e, n, o, i) {
                (o && r.isFunction(o)) || (o = function() {}),
                  r.addParamsAndAccessTokenToPath(t, e, n),
                  a(t, r.formatUrl(e), 'GET', null, o, i);
              },
              post: function(t, e, n, i, s) {
                if (((i && r.isFunction(i)) || (i = function() {}), !n))
                  return i(new Error('Cannot send empty request'));
                var u = o.truncate(n);
                if (u.error) return i(u.error);
                var c = u.value;
                a(t, r.formatUrl(e), 'POST', c, i, s);
              },
              postJsonPayload: function(t, e, n, o, i) {
                (o && r.isFunction(o)) || (o = function() {}),
                  a(t, r.formatUrl(e), 'POST', n, o, i);
              },
            };
          },
          function(t, e, n) {
            var r = n(0),
              o = n(4),
              i = n(1);
            function a(t, e, n) {
              var o = t.message,
                i = t.custom;
              o || (o = 'Item sent with null or missing arguments.');
              var a = { body: o };
              i && (a.extra = r.merge(i)),
                r.set(t, 'data.body', { message: a }),
                n(null, t);
            }
            function s(t) {
              var e = t.stackInfo.stack;
              return (
                e &&
                  0 === e.length &&
                  t._unhandledStackInfo &&
                  t._unhandledStackInfo.stack &&
                  (e = t._unhandledStackInfo.stack),
                e
              );
            }
            function u(t, e, n) {
              var i = t && t.data.description,
                a = t && t.custom,
                u = s(t),
                l = o.guessErrorClass(e.message),
                p = { exception: { class: c(e, l[0], n), message: l[1] } };
              if ((i && (p.exception.description = i), u)) {
                var f, d, h, m, g, v, y, b;
                for (
                  0 === u.length &&
                    ((p.exception.stack = e.rawStack),
                    (p.exception.raw = String(e.rawException))),
                    p.frames = [],
                    y = 0;
                  y < u.length;
                  ++y
                )
                  (d = {
                    filename: (f = u[y]).url
                      ? r.sanitizeUrl(f.url)
                      : '(unknown)',
                    lineno: f.line || null,
                    method: f.func && '?' !== f.func ? f.func : '[anonymous]',
                    colno: f.column,
                  }),
                    n.sendFrameUrl && (d.url = f.url),
                    (d.method &&
                      d.method.endsWith &&
                      d.method.endsWith('_rollbar_wrapped')) ||
                      ((h = m = g = null),
                      (v = f.context ? f.context.length : 0) &&
                        ((b = Math.floor(v / 2)),
                        (m = f.context.slice(0, b)),
                        (h = f.context[b]),
                        (g = f.context.slice(b))),
                      h && (d.code = h),
                      (m || g) &&
                        ((d.context = {}),
                        m && m.length && (d.context.pre = m),
                        g && g.length && (d.context.post = g)),
                      f.args && (d.args = f.args),
                      p.frames.push(d));
                p.frames.reverse(), a && (p.extra = r.merge(a));
              }
              return p;
            }
            function c(t, e, n) {
              return t.name ? t.name : n.guessErrorClass ? e : '(unknown)';
            }
            t.exports = {
              handleDomException: function(t, e, n) {
                if (t.err && 'DOMException' === o.Stack(t.err).name) {
                  var r = new Error();
                  (r.name = t.err.name),
                    (r.message = t.err.message),
                    (r.stack = t.err.stack),
                    (r.nested = t.err),
                    (t.err = r);
                }
                n(null, t);
              },
              handleItemWithError: function(t, e, n) {
                if (((t.data = t.data || {}), t.err))
                  try {
                    t.stackInfo = t.err._savedStackTrace || o.parse(t.err);
                  } catch (e) {
                    i.error('Error while parsing the error object.', e);
                    try {
                      t.message =
                        t.err.message ||
                        t.err.description ||
                        t.message ||
                        String(t.err);
                    } catch (e) {
                      t.message = String(t.err) || String(e);
                    }
                    delete t.err;
                  }
                n(null, t);
              },
              ensureItemHasSomethingToSay: function(t, e, n) {
                t.message ||
                  t.stackInfo ||
                  t.custom ||
                  n(new Error('No message, stack info, or custom data'), null),
                  n(null, t);
              },
              addBaseInfo: function(t, e, n) {
                var o = (e.payload && e.payload.environment) || e.environment;
                (t.data = r.merge(t.data, {
                  environment: o,
                  level: t.level,
                  endpoint: e.endpoint,
                  platform: 'browser',
                  framework: 'browser-js',
                  language: 'javascript',
                  server: {},
                  uuid: t.uuid,
                  notifier: { name: 'rollbar-browser-js', version: e.version },
                })),
                  n(null, t);
              },
              addRequestInfo: function(t) {
                return function(e, n, o) {
                  if (!t || !t.location) return o(null, e);
                  var i = '$remote_ip';
                  n.captureIp
                    ? !0 !== n.captureIp && (i += '_anonymize')
                    : (i = null),
                    r.set(e, 'data.request', {
                      url: t.location.href,
                      query_string: t.location.search,
                      user_ip: i,
                    }),
                    o(null, e);
                };
              },
              addClientInfo: function(t) {
                return function(e, n, o) {
                  if (!t) return o(null, e);
                  var i = t.navigator || {},
                    a = t.screen || {};
                  r.set(e, 'data.client', {
                    runtime_ms: e.timestamp - t._rollbarStartTime,
                    timestamp: Math.round(e.timestamp / 1e3),
                    javascript: {
                      browser: i.userAgent,
                      language: i.language,
                      cookie_enabled: i.cookieEnabled,
                      screen: { width: a.width, height: a.height },
                    },
                  }),
                    o(null, e);
                };
              },
              addPluginInfo: function(t) {
                return function(e, n, o) {
                  if (!t || !t.navigator) return o(null, e);
                  for (
                    var i,
                      a = [],
                      s = t.navigator.plugins || [],
                      u = 0,
                      c = s.length;
                    u < c;
                    ++u
                  )
                    (i = s[u]),
                      a.push({ name: i.name, description: i.description });
                  r.set(e, 'data.client.javascript.plugins', a), o(null, e);
                };
              },
              addBody: function(t, e, n) {
                t.stackInfo
                  ? t.stackInfo.traceChain
                    ? (function(t, e, n) {
                        for (
                          var o = t.stackInfo.traceChain,
                            i = [],
                            a = o.length,
                            s = 0;
                          s < a;
                          s++
                        ) {
                          var c = u(t, o[s], e);
                          i.push(c);
                        }
                        r.set(t, 'data.body', { trace_chain: i }), n(null, t);
                      })(t, e, n)
                    : (function(t, e, n) {
                        if (s(t)) {
                          var i = u(t, t.stackInfo, e);
                          r.set(t, 'data.body', { trace: i }), n(null, t);
                        } else {
                          var l = t.stackInfo,
                            p = o.guessErrorClass(l.message),
                            f = c(l, p[0], e),
                            d = p[1];
                          (t.message = f + ': ' + d), a(t, 0, n);
                        }
                      })(t, e, n)
                  : a(t, 0, n);
              },
              scrubPayload: function(t, e, n) {
                var o = e.scrubFields;
                (t.data = r.scrub(t.data, o)), n(null, t);
              },
            };
          },
          function(t, e, n) {
            var r, o, i;
            !(function(a, s) {
              (o = [n(23)]),
                void 0 ===
                  (i =
                    'function' ==
                    typeof (r = function(t) {
                      var e = /(^|@)\S+\:\d+/,
                        n = /^\s*at .*(\S+\:\d+|\(native\))/m,
                        r = /^(eval@)?(\[native code\])?$/;
                      return {
                        parse: function(t) {
                          if (
                            void 0 !== t.stacktrace ||
                            void 0 !== t['opera#sourceloc']
                          )
                            return this.parseOpera(t);
                          if (t.stack && t.stack.match(n))
                            return this.parseV8OrIE(t);
                          if (t.stack) return this.parseFFOrSafari(t);
                          throw new Error('Cannot parse given Error object');
                        },
                        extractLocation: function(t) {
                          if (-1 === t.indexOf(':')) return [t];
                          var e = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/.exec(
                            t.replace(/[\(\)]/g, ''),
                          );
                          return [e[1], e[2] || void 0, e[3] || void 0];
                        },
                        parseV8OrIE: function(e) {
                          return e.stack
                            .split('\n')
                            .filter(function(t) {
                              return !!t.match(n);
                            }, this)
                            .map(function(e) {
                              -1 < e.indexOf('(eval ') &&
                                (e = e
                                  .replace(/eval code/g, 'eval')
                                  .replace(
                                    /(\(eval at [^\()]*)|(\)\,.*$)/g,
                                    '',
                                  ));
                              var n = e
                                  .replace(/^\s+/, '')
                                  .replace(/\(eval code/g, '('),
                                r = n.match(/ (\((.+):(\d+):(\d+)\)$)/),
                                o = (n = r ? n.replace(r[0], '') : n)
                                  .split(/\s+/)
                                  .slice(1),
                                i = this.extractLocation(r ? r[1] : o.pop()),
                                a = o.join(' ') || void 0,
                                s =
                                  -1 < ['eval', '<anonymous>'].indexOf(i[0])
                                    ? void 0
                                    : i[0];
                              return new t({
                                functionName: a,
                                fileName: s,
                                lineNumber: i[1],
                                columnNumber: i[2],
                                source: e,
                              });
                            }, this);
                        },
                        parseFFOrSafari: function(e) {
                          return e.stack
                            .split('\n')
                            .filter(function(t) {
                              return !t.match(r);
                            }, this)
                            .map(function(e) {
                              if (
                                (-1 < e.indexOf(' > eval') &&
                                  (e = e.replace(
                                    / line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g,
                                    ':$1',
                                  )),
                                -1 === e.indexOf('@') && -1 === e.indexOf(':'))
                              )
                                return new t({ functionName: e });
                              var n = /((.*".+"[^@]*)?[^@]*)(?:@)/,
                                r = e.match(n),
                                o = r && r[1] ? r[1] : void 0,
                                i = this.extractLocation(e.replace(n, ''));
                              return new t({
                                functionName: o,
                                fileName: i[0],
                                lineNumber: i[1],
                                columnNumber: i[2],
                                source: e,
                              });
                            }, this);
                        },
                        parseOpera: function(t) {
                          return !t.stacktrace ||
                            (-1 < t.message.indexOf('\n') &&
                              t.message.split('\n').length >
                                t.stacktrace.split('\n').length)
                            ? this.parseOpera9(t)
                            : t.stack
                            ? this.parseOpera11(t)
                            : this.parseOpera10(t);
                        },
                        parseOpera9: function(e) {
                          for (
                            var n = /Line (\d+).*script (?:in )?(\S+)/i,
                              r = e.message.split('\n'),
                              o = [],
                              i = 2,
                              a = r.length;
                            i < a;
                            i += 2
                          ) {
                            var s = n.exec(r[i]);
                            s &&
                              o.push(
                                new t({
                                  fileName: s[2],
                                  lineNumber: s[1],
                                  source: r[i],
                                }),
                              );
                          }
                          return o;
                        },
                        parseOpera10: function(e) {
                          for (
                            var n = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i,
                              r = e.stacktrace.split('\n'),
                              o = [],
                              i = 0,
                              a = r.length;
                            i < a;
                            i += 2
                          ) {
                            var s = n.exec(r[i]);
                            s &&
                              o.push(
                                new t({
                                  functionName: s[3] || void 0,
                                  fileName: s[2],
                                  lineNumber: s[1],
                                  source: r[i],
                                }),
                              );
                          }
                          return o;
                        },
                        parseOpera11: function(n) {
                          return n.stack
                            .split('\n')
                            .filter(function(t) {
                              return (
                                !!t.match(e) && !t.match(/^Error created at/)
                              );
                            }, this)
                            .map(function(e) {
                              var n,
                                r = e.split('@'),
                                o = this.extractLocation(r.pop()),
                                i = r.shift() || '',
                                a =
                                  i
                                    .replace(
                                      /<anonymous function(: (\w+))?>/,
                                      '$2',
                                    )
                                    .replace(/\([^\)]*\)/g, '') || void 0;
                              i.match(/\(([^\)]*)\)/) &&
                                (n = i.replace(/^[^\(]+\(([^\)]*)\)$/, '$1'));
                              var s =
                                void 0 === n ||
                                '[arguments not available]' === n
                                  ? void 0
                                  : n.split(',');
                              return new t({
                                functionName: a,
                                args: s,
                                fileName: o[0],
                                lineNumber: o[1],
                                columnNumber: o[2],
                                source: e,
                              });
                            }, this);
                        },
                      };
                    })
                      ? r.apply(e, o)
                      : r) || (t.exports = i);
            })();
          },
          function(t, e, n) {
            var r, o, i;
            !(function(n, a) {
              (o = []),
                void 0 ===
                  (i =
                    'function' ==
                    typeof (r = function() {
                      function t(t) {
                        return t.charAt(0).toUpperCase() + t.substring(1);
                      }
                      function e(t) {
                        return function() {
                          return this[t];
                        };
                      }
                      var n = [
                          'isConstructor',
                          'isEval',
                          'isNative',
                          'isToplevel',
                        ],
                        r = ['columnNumber', 'lineNumber'],
                        o = ['fileName', 'functionName', 'source'],
                        i = n.concat(r, o, ['args']);
                      function a(e) {
                        if (e instanceof Object)
                          for (var n = 0; n < i.length; n++)
                            e.hasOwnProperty(i[n]) &&
                              void 0 !== e[i[n]] &&
                              this['set' + t(i[n])](e[i[n]]);
                      }
                      (a.prototype = {
                        getArgs: function() {
                          return this.args;
                        },
                        setArgs: function(t) {
                          if (
                            '[object Array]' !==
                            Object.prototype.toString.call(t)
                          )
                            throw new TypeError('Args must be an Array');
                          this.args = t;
                        },
                        getEvalOrigin: function() {
                          return this.evalOrigin;
                        },
                        setEvalOrigin: function(t) {
                          if (t instanceof a) this.evalOrigin = t;
                          else {
                            if (!(t instanceof Object))
                              throw new TypeError(
                                'Eval Origin must be an Object or StackFrame',
                              );
                            this.evalOrigin = new a(t);
                          }
                        },
                        toString: function() {
                          var t = this.getFileName() || '',
                            e = this.getLineNumber() || '',
                            n = this.getColumnNumber() || '',
                            r = this.getFunctionName() || '';
                          return this.getIsEval()
                            ? t
                              ? '[eval] (' + t + ':' + e + ':' + n + ')'
                              : '[eval]:' + e + ':' + n
                            : r
                            ? r + ' (' + t + ':' + e + ':' + n + ')'
                            : t + ':' + e + ':' + n;
                        },
                      }),
                        (a.fromString = function(t) {
                          var e = t.indexOf('('),
                            n = t.lastIndexOf(')'),
                            r = t.substring(0, e),
                            o = t.substring(e + 1, n).split(','),
                            i = t.substring(n + 1);
                          if (0 === i.indexOf('@'))
                            var s = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(i, ''),
                              u = s[1],
                              c = s[2],
                              l = s[3];
                          return new a({
                            functionName: r,
                            args: o || void 0,
                            fileName: u,
                            lineNumber: c || void 0,
                            columnNumber: l || void 0,
                          });
                        });
                      for (var s = 0; s < n.length; s++)
                        (a.prototype['get' + t(n[s])] = e(n[s])),
                          (a.prototype['set' + t(n[s])] = (function(t) {
                            return function(e) {
                              this[t] = Boolean(e);
                            };
                          })(n[s]));
                      for (var u = 0; u < r.length; u++)
                        (a.prototype['get' + t(r[u])] = e(r[u])),
                          (a.prototype['set' + t(r[u])] = (function(t) {
                            return function(e) {
                              if (
                                ((n = e), isNaN(parseFloat(n)) || !isFinite(n))
                              )
                                throw new TypeError(t + ' must be a Number');
                              var n;
                              this[t] = Number(e);
                            };
                          })(r[u]));
                      for (var c = 0; c < o.length; c++)
                        (a.prototype['get' + t(o[c])] = e(o[c])),
                          (a.prototype['set' + t(o[c])] = (function(t) {
                            return function(e) {
                              this[t] = String(e);
                            };
                          })(o[c]));
                      return a;
                    })
                      ? r.apply(e, o)
                      : r) || (t.exports = i);
            })();
          },
          function(t, e, n) {
            var r = n(0);
            t.exports = {
              itemToPayload: function(t, e, n) {
                var o = e.payload || {};
                o.body && delete o.body;
                var i = r.merge(t.data, o);
                t._isUncaught && (i._isUncaught = !0),
                  t._originalArgs && (i._originalArgs = t._originalArgs),
                  n(null, i);
              },
              addTelemetryData: function(t, e, n) {
                t.telemetryEvents &&
                  r.set(t, 'data.body.telemetry', t.telemetryEvents),
                  n(null, t);
              },
              addMessageWithError: function(t, e, n) {
                if (t.message) {
                  var o = 'data.body.trace_chain.0',
                    i = r.get(t, o);
                  if ((i || ((o = 'data.body.trace'), (i = r.get(t, o))), i)) {
                    if (!i.exception || !i.exception.description)
                      return (
                        r.set(t, o + '.exception.description', t.message),
                        void n(null, t)
                      );
                    var a = r.get(t, o + '.extra') || {},
                      s = r.merge(a, { message: t.message });
                    r.set(t, o + '.extra', s);
                  }
                  n(null, t);
                } else n(null, t);
              },
              userTransform: function(t) {
                return function(e, n, o) {
                  var i = r.merge(e);
                  try {
                    r.isFunction(n.transform) && n.transform(i.data, e);
                  } catch (i) {
                    return (
                      (n.transform = null),
                      t.error(
                        'Error while calling custom transform() function. Removing custom transform().',
                        i,
                      ),
                      void o(null, e)
                    );
                  }
                  o(null, i);
                };
              },
              addConfigToPayload: function(t, e, n) {
                if (!e.sendConfig) return n(null, t);
                var o = r.get(t, 'data.custom') || {};
                (o._rollbarConfig = e), (t.data.custom = o), n(null, t);
              },
              addConfiguredOptions: function(t, e, n) {
                delete e._configuredOptions.accessToken,
                  (t.data.notifier.configured_options = e._configuredOptions),
                  n(null, t);
              },
              addDiagnosticKeys: function(t, e, n) {
                var o = r.merge(
                  t.notifier.client.notifier.diagnostic,
                  t.diagnostic,
                );
                if (
                  (r.get(t, 'err._isAnonymous') && (o.is_anonymous = !0), t.err)
                )
                  try {
                    o.raw_error = {
                      message: t.err.message,
                      name: t.err.name,
                      constructor_name:
                        t.err.constructor && t.err.constructor.name,
                      filename: t.err.fileName,
                      line: t.err.lineNumber,
                      column: t.err.columnNumber,
                      stack: t.err.stack,
                    };
                  } catch (t) {
                    o.raw_error = { failed: String(t) };
                  }
                (t.data.notifier.diagnostic = r.merge(
                  t.data.notifier.diagnostic,
                  o,
                )),
                  n(null, t);
              },
            };
          },
          function(t, e, n) {
            var r = n(0);
            t.exports = {
              checkIgnore: function(t, e) {
                return (
                  !r.get(e, 'plugins.jquery.ignoreAjaxErrors') ||
                  !r.get(t, 'body.message.extra.isAjax')
                );
              },
            };
          },
          function(t, e, n) {
            var r = n(0);
            function o(t, e, n) {
              if (!t) return !n;
              var o,
                i,
                a = t.frames;
              if (!a || 0 === a.length) return !n;
              for (var s = e.length, u = a.length, c = 0; c < u; c++) {
                if (((o = a[c].filename), !r.isType(o, 'string'))) return !n;
                for (var l = 0; l < s; l++)
                  if (((i = e[l]), new RegExp(i).test(o))) return !0;
              }
              return !1;
            }
            function i(t, e, n, i) {
              var a,
                s,
                u = !1;
              'blacklist' === n && (u = !0);
              try {
                if (
                  ((a = u ? e.hostBlackList : e.hostWhiteList),
                  (s = r.get(t, 'body.trace_chain') || [
                    r.get(t, 'body.trace'),
                  ]),
                  !a || 0 === a.length)
                )
                  return !u;
                if (0 === s.length || !s[0]) return !u;
                for (var c = s.length, l = 0; l < c; l++)
                  if (o(s[l], a, u)) return !0;
              } catch (t) {
                u ? (e.hostBlackList = null) : (e.hostWhiteList = null);
                var p = u ? 'hostBlackList' : 'hostWhiteList';
                return (
                  i.error(
                    "Error while reading your configuration's " +
                      p +
                      ' option. Removing custom ' +
                      p +
                      '.',
                    t,
                  ),
                  !u
                );
              }
              return !1;
            }
            t.exports = {
              checkLevel: function(t, e) {
                var n = t.level,
                  o = r.LEVELS[n] || 0,
                  i = e.reportLevel;
                return !(o < (r.LEVELS[i] || 0));
              },
              userCheckIgnore: function(t) {
                return function(e, n) {
                  var o = !!e._isUncaught;
                  delete e._isUncaught;
                  var i = e._originalArgs;
                  delete e._originalArgs;
                  try {
                    r.isFunction(n.onSendCallback) && n.onSendCallback(o, i, e);
                  } catch (e) {
                    (n.onSendCallback = null),
                      t.error(
                        'Error while calling onSendCallback, removing',
                        e,
                      );
                  }
                  try {
                    if (r.isFunction(n.checkIgnore) && n.checkIgnore(o, i, e))
                      return !1;
                  } catch (e) {
                    (n.checkIgnore = null),
                      t.error(
                        'Error while calling custom checkIgnore(), removing',
                        e,
                      );
                  }
                  return !0;
                };
              },
              urlIsNotBlacklisted: function(t) {
                return function(e, n) {
                  return !i(e, n, 'blacklist', t);
                };
              },
              urlIsWhitelisted: function(t) {
                return function(e, n) {
                  return i(e, n, 'whitelist', t);
                };
              },
              messageIsIgnored: function(t) {
                return function(e, n) {
                  var o, i, a, s, u, c, l, p;
                  try {
                    if (((u = !1), !(a = n.ignoredMessages) || 0 === a.length))
                      return !0;
                    if (
                      ((c = e.body),
                      (l = r.get(c, 'trace.exception.message')),
                      (p = r.get(c, 'message.body')),
                      !(o = l || p))
                    )
                      return !0;
                    for (
                      s = a.length, i = 0;
                      i < s && !(u = new RegExp(a[i], 'gi').test(o));
                      i++
                    );
                  } catch (e) {
                    (n.ignoredMessages = null),
                      t.error(
                        "Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.",
                      );
                  }
                  return !u;
                };
              },
            };
          },
          function(t, e, n) {
            var r = n(0),
              o = n(3),
              i = n(28),
              a = {
                network: !0,
                networkResponseHeaders: !1,
                networkResponseBody: !1,
                networkRequestHeaders: !1,
                networkRequestBody: !1,
                log: !0,
                dom: !0,
                navigation: !0,
                connectivity: !0,
              };
            function s(t, e, n, r, o) {
              var i = t[e];
              (t[e] = n(i)), r && r[o].push([t, e, i]);
            }
            function u(t, e) {
              for (var n; t[e].length; ) (n = t[e].shift())[0][n[1]] = n[2];
            }
            function c(t, e, n, o, i) {
              var s = (this.options = t).autoInstrument;
              !1 === t.enabled || !1 === s
                ? (this.autoInstrument = {})
                : (r.isType(s, 'object') || (s = a),
                  (this.autoInstrument = r.merge(a, s))),
                (this.scrubTelemetryInputs = !!t.scrubTelemetryInputs),
                (this.telemetryScrubber = t.telemetryScrubber),
                (this.defaultValueScrubber = (function(t) {
                  for (var e = [], n = 0; n < t.length; ++n)
                    e.push(new RegExp(t[n], 'i'));
                  return function(t) {
                    var n = (function(t) {
                      if (!t || !t.attributes) return null;
                      for (var e = t.attributes, n = 0; n < e.length; ++n)
                        if ('name' === e[n].key) return e[n].value;
                      return null;
                    })(t);
                    if (!n) return !1;
                    for (var r = 0; r < e.length; ++r)
                      if (e[r].test(n)) return !0;
                    return !1;
                  };
                })(t.scrubFields)),
                (this.telemeter = e),
                (this.rollbar = n),
                (this.diagnostic = n.client.notifier.diagnostic),
                (this._window = o || {}),
                (this._document = i || {}),
                (this.replacements = {
                  network: [],
                  log: [],
                  navigation: [],
                  connectivity: [],
                }),
                (this.eventRemovers = { dom: [], connectivity: [] }),
                (this._location = this._window.location),
                (this._lastHref = this._location && this._location.href);
            }
            (c.prototype.configure = function(t) {
              this.options = r.merge(this.options, t);
              var e = t.autoInstrument,
                n = r.merge(this.autoInstrument);
              !1 === t.enabled || !1 === e
                ? (this.autoInstrument = {})
                : (r.isType(e, 'object') || (e = a),
                  (this.autoInstrument = r.merge(a, e))),
                this.instrument(n),
                void 0 !== t.scrubTelemetryInputs &&
                  (this.scrubTelemetryInputs = !!t.scrubTelemetryInputs),
                void 0 !== t.telemetryScrubber &&
                  (this.telemetryScrubber = t.telemetryScrubber);
            }),
              (c.prototype.instrument = function(t) {
                !this.autoInstrument.network || (t && t.network)
                  ? !this.autoInstrument.network &&
                    t &&
                    t.network &&
                    this.deinstrumentNetwork()
                  : this.instrumentNetwork(),
                  !this.autoInstrument.log || (t && t.log)
                    ? !this.autoInstrument.log &&
                      t &&
                      t.log &&
                      this.deinstrumentConsole()
                    : this.instrumentConsole(),
                  !this.autoInstrument.dom || (t && t.dom)
                    ? !this.autoInstrument.dom &&
                      t &&
                      t.dom &&
                      this.deinstrumentDom()
                    : this.instrumentDom(),
                  !this.autoInstrument.navigation || (t && t.navigation)
                    ? !this.autoInstrument.navigation &&
                      t &&
                      t.navigation &&
                      this.deinstrumentNavigation()
                    : this.instrumentNavigation(),
                  !this.autoInstrument.connectivity || (t && t.connectivity)
                    ? !this.autoInstrument.connectivity &&
                      t &&
                      t.connectivity &&
                      this.deinstrumentConnectivity()
                    : this.instrumentConnectivity();
              }),
              (c.prototype.deinstrumentNetwork = function() {
                u(this.replacements, 'network');
              }),
              (c.prototype.instrumentNetwork = function() {
                var t = this;
                function e(e, n) {
                  e in n &&
                    r.isFunction(n[e]) &&
                    s(n, e, function(e) {
                      return t.rollbar.wrap(e);
                    });
                }
                if ('XMLHttpRequest' in this._window) {
                  var n = this._window.XMLHttpRequest.prototype;
                  s(
                    n,
                    'open',
                    function(e) {
                      return function(n, o) {
                        return (
                          r.isType(o, 'string') &&
                            ((this.__rollbar_xhr = {
                              method: n,
                              url: o,
                              status_code: null,
                              start_time_ms: r.now(),
                              end_time_ms: null,
                            }),
                            t.autoInstrument.networkRequestHeaders &&
                              (this.__rollbar_xhr.request_headers = {})),
                          e.apply(this, arguments)
                        );
                      };
                    },
                    this.replacements,
                    'network',
                  ),
                    s(
                      n,
                      'setRequestHeader',
                      function(e) {
                        return function(n, o) {
                          return (
                            t.autoInstrument.networkRequestHeaders &&
                              this.__rollbar_xhr &&
                              r.isType(n, 'string') &&
                              r.isType(o, 'string') &&
                              (this.__rollbar_xhr.request_headers[n] = o),
                            'content-type' === n.toLowerCase() &&
                              (this.__rollbar_xhr.request_content_type = o),
                            e.apply(this, arguments)
                          );
                        };
                      },
                      this.replacements,
                      'network',
                    ),
                    s(
                      n,
                      'send',
                      function(n) {
                        return function(o) {
                          var i = this;
                          function a() {
                            if (
                              i.__rollbar_xhr &&
                              (null === i.__rollbar_xhr.status_code &&
                                ((i.__rollbar_xhr.status_code = 0),
                                t.autoInstrument.networkRequestBody &&
                                  (i.__rollbar_xhr.request = o),
                                (i.__rollbar_event = t.captureNetwork(
                                  i.__rollbar_xhr,
                                  'xhr',
                                  void 0,
                                ))),
                              i.readyState < 2 &&
                                (i.__rollbar_xhr.start_time_ms = r.now()),
                              3 < i.readyState)
                            ) {
                              i.__rollbar_xhr.end_time_ms = r.now();
                              var e = null;
                              if (
                                ((i.__rollbar_xhr.response_content_type = i.getResponseHeader(
                                  'Content-Type',
                                )),
                                t.autoInstrument.networkResponseHeaders)
                              ) {
                                var n = t.autoInstrument.networkResponseHeaders;
                                e = {};
                                try {
                                  var a, s;
                                  if (!0 === n) {
                                    var u = i.getAllResponseHeaders();
                                    if (u) {
                                      var c,
                                        l,
                                        p = u.trim().split(/[\r\n]+/);
                                      for (s = 0; s < p.length; s++)
                                        (a = (c = p[s].split(': ')).shift()),
                                          (l = c.join(': ')),
                                          (e[a] = l);
                                    }
                                  } else
                                    for (s = 0; s < n.length; s++)
                                      e[(a = n[s])] = i.getResponseHeader(a);
                                } catch (e) {}
                              }
                              var f = null;
                              if (t.autoInstrument.networkResponseBody)
                                try {
                                  f = i.responseText;
                                } catch (e) {}
                              var d = null;
                              (f || e) &&
                                ((d = {}),
                                f &&
                                  (t.isJsonContentType(
                                    i.__rollbar_xhr.request_content_type,
                                  )
                                    ? (d.body = t.scrubJson(f))
                                    : (d.body = f)),
                                e && (d.headers = e)),
                                d && (i.__rollbar_xhr.response = d);
                              try {
                                var h = i.status;
                                (h = 1223 === h ? 204 : h),
                                  (i.__rollbar_xhr.status_code = h),
                                  (i.__rollbar_event.level = t.telemeter.levelFromStatus(
                                    h,
                                  ));
                              } catch (e) {}
                            }
                          }
                          return (
                            e('onload', i),
                            e('onerror', i),
                            e('onprogress', i),
                            'onreadystatechange' in i &&
                            r.isFunction(i.onreadystatechange)
                              ? s(i, 'onreadystatechange', function(e) {
                                  return t.rollbar.wrap(e, void 0, a);
                                })
                              : (i.onreadystatechange = a),
                            n.apply(this, arguments)
                          );
                        };
                      },
                      this.replacements,
                      'network',
                    );
                }
                'fetch' in this._window &&
                  s(
                    this._window,
                    'fetch',
                    function(e) {
                      return function(n, o) {
                        for (
                          var i = new Array(arguments.length),
                            a = 0,
                            s = i.length;
                          a < s;
                          a++
                        )
                          i[a] = arguments[a];
                        var u,
                          c = i[0],
                          l = 'GET';
                        r.isType(c, 'string')
                          ? (u = c)
                          : c && ((u = c.url), c.method && (l = c.method)),
                          i[1] && i[1].method && (l = i[1].method);
                        var p = {
                          method: l,
                          url: u,
                          status_code: null,
                          start_time_ms: r.now(),
                          end_time_ms: null,
                        };
                        if (i[1] && i[1].headers) {
                          var f = new Headers(i[1].headers);
                          (p.request_content_type = f.get('Content-Type')),
                            t.autoInstrument.networkRequestHeaders &&
                              (p.request_headers = t.fetchHeaders(
                                f,
                                t.autoInstrument.networkRequestHeaders,
                              ));
                        }
                        return (
                          t.autoInstrument.networkRequestBody &&
                            (i[1] && i[1].body
                              ? (p.request = i[1].body)
                              : i[0] &&
                                !r.isType(i[0], 'string') &&
                                i[0].body &&
                                (p.request = i[0].body)),
                          t.captureNetwork(p, 'fetch', void 0),
                          e.apply(this, i).then(function(e) {
                            (p.end_time_ms = r.now()),
                              (p.status_code = e.status),
                              (p.response_content_type = e.headers.get(
                                'Content-Type',
                              ));
                            var n = null;
                            t.autoInstrument.networkResponseHeaders &&
                              (n = t.fetchHeaders(
                                e.headers,
                                t.autoInstrument.networkResponseHeaders,
                              ));
                            var o = null;
                            return (
                              !t.autoInstrument.networkResponseBody ||
                                ('function' == typeof e.text && (o = e.text())),
                              (n || o) &&
                                ((p.response = {}),
                                o &&
                                  ('function' == typeof o.then
                                    ? o.then(function(e) {
                                        t.isJsonContentType(
                                          p.response_content_type,
                                        ) && (p.response.body = t.scrubJson(e));
                                      })
                                    : (p.response.body = o)),
                                n && (p.response.headers = n)),
                              e
                            );
                          })
                        );
                      };
                    },
                    this.replacements,
                    'network',
                  );
              }),
              (c.prototype.captureNetwork = function(t, e, n) {
                return (
                  t.request &&
                    this.isJsonContentType(t.request_content_type) &&
                    (t.request = this.scrubJson(t.request)),
                  this.telemeter.captureNetwork(t, e, n)
                );
              }),
              (c.prototype.isJsonContentType = function(t) {
                return !(!t || !t.toLowerCase().includes('json'));
              }),
              (c.prototype.scrubJson = function(t) {
                return JSON.stringify(
                  r.scrub(JSON.parse(t), this.options.scrubFields),
                );
              }),
              (c.prototype.fetchHeaders = function(t, e) {
                var n = {};
                try {
                  var r;
                  if (!0 === e) {
                    if ('function' == typeof t.entries)
                      for (var o = t.entries(), i = o.next(); !i.done; )
                        (n[i.value[0]] = i.value[1]), (i = o.next());
                  } else
                    for (r = 0; r < e.length; r++) {
                      var a = e[r];
                      n[a] = t.get(a);
                    }
                } catch (t) {}
                return n;
              }),
              (c.prototype.deinstrumentConsole = function() {
                if ('console' in this._window && this._window.console.log)
                  for (var t; this.replacements.log.length; )
                    (t = this.replacements.log.shift()),
                      (this._window.console[t[0]] = t[1]);
              }),
              (c.prototype.instrumentConsole = function() {
                if ('console' in this._window && this._window.console.log) {
                  var t = this,
                    e = this._window.console,
                    n = ['debug', 'info', 'warn', 'error', 'log'];
                  try {
                    for (var o = 0, i = n.length; o < i; o++) a(n[o]);
                  } catch (n) {
                    this.diagnostic.instrumentConsole = { error: n.message };
                  }
                }
                function a(n) {
                  var o = e[n],
                    i = e,
                    a = 'warn' === n ? 'warning' : n;
                  (e[n] = function() {
                    var e = Array.prototype.slice.call(arguments),
                      n = r.formatArgsAsString(e);
                    t.telemeter.captureLog(n, a),
                      o && Function.prototype.apply.call(o, i, e);
                  }),
                    t.replacements.log.push([n, o]);
                }
              }),
              (c.prototype.deinstrumentDom = function() {
                ('addEventListener' in this._window ||
                  'attachEvent' in this._window) &&
                  this.removeListeners('dom');
              }),
              (c.prototype.instrumentDom = function() {
                if (
                  'addEventListener' in this._window ||
                  'attachEvent' in this._window
                ) {
                  var t = this.handleClick.bind(this),
                    e = this.handleBlur.bind(this);
                  this.addListener(
                    'dom',
                    this._window,
                    'click',
                    'onclick',
                    t,
                    !0,
                  ),
                    this.addListener(
                      'dom',
                      this._window,
                      'blur',
                      'onfocusout',
                      e,
                      !0,
                    );
                }
              }),
              (c.prototype.handleClick = function(t) {
                try {
                  var e = i.getElementFromEvent(t, this._document),
                    n = e && e.tagName,
                    r =
                      i.isDescribedElement(e, 'a') ||
                      i.isDescribedElement(e, 'button');
                  n &&
                  (r || i.isDescribedElement(e, 'input', ['button', 'submit']))
                    ? this.captureDomEvent('click', e)
                    : i.isDescribedElement(e, 'input', ['checkbox', 'radio']) &&
                      this.captureDomEvent('input', e, e.value, e.checked);
                } catch (t) {}
              }),
              (c.prototype.handleBlur = function(t) {
                try {
                  var e = i.getElementFromEvent(t, this._document);
                  e &&
                    e.tagName &&
                    (i.isDescribedElement(e, 'textarea')
                      ? this.captureDomEvent('input', e, e.value)
                      : i.isDescribedElement(e, 'select') &&
                        e.options &&
                        e.options.length
                      ? this.handleSelectInputChanged(e)
                      : i.isDescribedElement(e, 'input') &&
                        !i.isDescribedElement(e, 'input', [
                          'button',
                          'submit',
                          'hidden',
                          'checkbox',
                          'radio',
                        ]) &&
                        this.captureDomEvent('input', e, e.value));
                } catch (t) {}
              }),
              (c.prototype.handleSelectInputChanged = function(t) {
                if (t.multiple)
                  for (var e = 0; e < t.options.length; e++)
                    t.options[e].selected &&
                      this.captureDomEvent('input', t, t.options[e].value);
                else
                  0 <= t.selectedIndex &&
                    t.options[t.selectedIndex] &&
                    this.captureDomEvent(
                      'input',
                      t,
                      t.options[t.selectedIndex].value,
                    );
              }),
              (c.prototype.captureDomEvent = function(t, e, n, r) {
                if (void 0 !== n)
                  if (
                    this.scrubTelemetryInputs ||
                    'password' === i.getElementType(e)
                  )
                    n = '[scrubbed]';
                  else {
                    var o = i.describeElement(e);
                    this.telemetryScrubber
                      ? this.telemetryScrubber(o) && (n = '[scrubbed]')
                      : this.defaultValueScrubber(o) && (n = '[scrubbed]');
                  }
                var a = i.elementArrayToString(i.treeToArray(e));
                this.telemeter.captureDom(t, a, n, r);
              }),
              (c.prototype.deinstrumentNavigation = function() {
                var t = this._window.chrome;
                (t && t.app && t.app.runtime) ||
                  !this._window.history ||
                  !this._window.history.pushState ||
                  u(this.replacements, 'navigation');
              }),
              (c.prototype.instrumentNavigation = function() {
                var t = this._window.chrome;
                if (
                  !(t && t.app && t.app.runtime) &&
                  this._window.history &&
                  this._window.history.pushState
                ) {
                  var e = this;
                  s(
                    this._window,
                    'onpopstate',
                    function(t) {
                      return function() {
                        var n = e._location.href;
                        e.handleUrlChange(e._lastHref, n),
                          t && t.apply(this, arguments);
                      };
                    },
                    this.replacements,
                    'navigation',
                  ),
                    s(
                      this._window.history,
                      'pushState',
                      function(t) {
                        return function() {
                          var n = 2 < arguments.length ? arguments[2] : void 0;
                          return (
                            n && e.handleUrlChange(e._lastHref, n + ''),
                            t.apply(this, arguments)
                          );
                        };
                      },
                      this.replacements,
                      'navigation',
                    );
                }
              }),
              (c.prototype.handleUrlChange = function(t, e) {
                var n = o.parse(this._location.href),
                  r = o.parse(e),
                  i = o.parse(t);
                (this._lastHref = e),
                  n.protocol === r.protocol &&
                    n.host === r.host &&
                    (e = r.path + (r.hash || '')),
                  n.protocol === i.protocol &&
                    n.host === i.host &&
                    (t = i.path + (i.hash || '')),
                  this.telemeter.captureNavigation(t, e);
              }),
              (c.prototype.deinstrumentConnectivity = function() {
                ('addEventListener' in this._window ||
                  'body' in this._document) &&
                  (this._window.addEventListener
                    ? this.removeListeners('connectivity')
                    : u(this.replacements, 'connectivity'));
              }),
              (c.prototype.instrumentConnectivity = function() {
                if (
                  'addEventListener' in this._window ||
                  'body' in this._document
                )
                  if (this._window.addEventListener)
                    this.addListener(
                      'connectivity',
                      this._window,
                      'online',
                      void 0,
                      function() {
                        this.telemeter.captureConnectivityChange('online');
                      }.bind(this),
                      !0,
                    ),
                      this.addListener(
                        'connectivity',
                        this._window,
                        'offline',
                        void 0,
                        function() {
                          this.telemeter.captureConnectivityChange('offline');
                        }.bind(this),
                        !0,
                      );
                  else {
                    var t = this;
                    s(
                      this._document.body,
                      'ononline',
                      function(e) {
                        return function() {
                          t.telemeter.captureConnectivityChange('online'),
                            e && e.apply(this, arguments);
                        };
                      },
                      this.replacements,
                      'connectivity',
                    ),
                      s(
                        this._document.body,
                        'onoffline',
                        function(e) {
                          return function() {
                            t.telemeter.captureConnectivityChange('offline'),
                              e && e.apply(this, arguments);
                          };
                        },
                        this.replacements,
                        'connectivity',
                      );
                  }
              }),
              (c.prototype.addListener = function(t, e, n, r, o, i) {
                e.addEventListener
                  ? (e.addEventListener(n, o, i),
                    this.eventRemovers[t].push(function() {
                      e.removeEventListener(n, o, i);
                    }))
                  : r &&
                    (e.attachEvent(r, o),
                    this.eventRemovers[t].push(function() {
                      e.detachEvent(r, o);
                    }));
              }),
              (c.prototype.removeListeners = function(t) {
                for (; this.eventRemovers[t].length; )
                  this.eventRemovers[t].shift()();
              }),
              (t.exports = c);
          },
          function(t, e, n) {
            function r(t) {
              return (t.getAttribute('type') || '').toLowerCase();
            }
            function o(t) {
              if (!t || !t.tagName) return '';
              var e = [t.tagName];
              t.id && e.push('#' + t.id),
                t.classes && e.push('.' + t.classes.join('.'));
              for (var n = 0; n < t.attributes.length; n++)
                e.push(
                  '[' +
                    t.attributes[n].key +
                    '="' +
                    t.attributes[n].value +
                    '"]',
                );
              return e.join('');
            }
            function i(t) {
              if (!t || !t.tagName) return null;
              var e,
                n,
                r,
                o,
                i = {};
              (i.tagName = t.tagName.toLowerCase()),
                t.id && (i.id = t.id),
                (e = t.className) &&
                  'string' == typeof e &&
                  (i.classes = e.split(/\s+/));
              var a = ['type', 'name', 'title', 'alt'];
              for (i.attributes = [], o = 0; o < a.length; o++)
                (n = a[o]),
                  (r = t.getAttribute(n)) &&
                    i.attributes.push({ key: n, value: r });
              return i;
            }
            t.exports = {
              describeElement: i,
              descriptionToString: o,
              elementArrayToString: function(t) {
                for (
                  var e, n, r = ' > '.length, i = [], a = 0, s = t.length - 1;
                  0 <= s;
                  s--
                ) {
                  if (
                    ((e = o(t[s])),
                    (n = a + i.length * r + e.length),
                    s < t.length - 1 && 83 <= n)
                  ) {
                    i.unshift('...');
                    break;
                  }
                  i.unshift(e), (a += e.length);
                }
                return i.join(' > ');
              },
              treeToArray: function(t) {
                for (
                  var e, n = [], r = 0;
                  t && r < 5 && 'html' !== (e = i(t)).tagName;
                  r++
                )
                  n.unshift(e), (t = t.parentNode);
                return n;
              },
              getElementFromEvent: function(t, e) {
                return t.target
                  ? t.target
                  : e && e.elementFromPoint
                  ? e.elementFromPoint(t.clientX, t.clientY)
                  : void 0;
              },
              isDescribedElement: function(t, e, n) {
                if (t.tagName.toLowerCase() !== e.toLowerCase()) return !1;
                if (!n) return !0;
                t = r(t);
                for (var o = 0; o < n.length; o++) if (n[o] === t) return !0;
                return !1;
              },
              getElementType: r,
            };
          },
        ]),
        (t.c = n),
        (t.d = function(e, n, r) {
          t.o(e, n) || Object.defineProperty(e, n, { enumerable: !0, get: r });
        }),
        (t.r = function(t) {
          'undefined' != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
            Object.defineProperty(t, '__esModule', { value: !0 });
        }),
        (t.t = function(e, n) {
          if ((1 & n && (e = t(e)), 8 & n)) return e;
          if (4 & n && 'object' == typeof e && e && e.__esModule) return e;
          var r = Object.create(null);
          if (
            (t.r(r),
            Object.defineProperty(r, 'default', { enumerable: !0, value: e }),
            2 & n && 'string' != typeof e)
          )
            for (var o in e)
              t.d(
                r,
                o,
                function(t) {
                  return e[t];
                }.bind(null, o),
              );
          return r;
        }),
        (t.n = function(e) {
          var n =
            e && e.__esModule
              ? function() {
                  return e.default;
                }
              : function() {
                  return e;
                };
          return t.d(n, 'a', n), n;
        }),
        (t.o = function(t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (t.p = ''),
        t((t.s = 5))
      );
      function t(r) {
        if (n[r]) return n[r].exports;
        var o = (n[r] = { i: r, l: !1, exports: {} });
        return e[r].call(o.exports, o, o.exports, t), (o.l = !0), o.exports;
      }
      var e, n;
    })();
  },
  function(t, e, n) {
    var r = n(5),
      o = n.n(r),
      i = n(6),
      a = n.n(i),
      s = n(7),
      u = n.n(s),
      c = n(1),
      l = n.n(c),
      p = n(0),
      f = n.n(p),
      d = n(2),
      h = n.n(d),
      m = n(3),
      g = n.n(m),
      v = n(4),
      y = n.n(v);
    function b() {
      var t =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : 'randomId',
        e = new Date().getDate(),
        n = ''.concat(Math.random()).replace(/[^\w\d]/, '');
      return [t, e, n].join('');
    }
    n(8);
    function w(t) {
      return ''
        .concat(
          'https://js.verygoodvault.com/vgs-collect/1/lib',
          '/index.html?',
        )
        .concat(
          (function(t) {
            var e = '';
            function n(t, n) {
              e.length > 0 && (e += '&'),
                (e += encodeURIComponent(t) + '=' + encodeURIComponent(n));
            }
            return (
              Object.keys(t)
                .sort()
                .forEach(function(e) {
                  var r = t[e];
                  Array.isArray(r)
                    ? r.forEach(function(t) {
                        return n(e, t);
                      })
                    : n(e, r);
                }),
              e
            );
          })(t),
        );
    }
    var _ = [
        'formId',
        'fieldId',
        'successColor',
        'errorColor',
        'lineHeight',
        'fontSize',
        'fontFamily',
        'color',
        'placeholder',
        'name',
        'validations',
        'type',
        'defaultValue',
        'serializers',
        'value',
        'defaultChecked',
        'autoComplete',
        'readOnly',
        'disabled',
        'maxLength',
        'autoFocus',
        'min',
        'max',
        'step',
        'ariaLabel',
        'modules',
        'tnt',
        'env',
        'inputMode',
      ],
      x = ['options', 'css', 'showCardIcon', 'yearLength'];
    function k(t, e) {
      var n,
        r,
        o,
        i = (function(t) {
          var e,
            n = document.createElement('iframe');
          return (
            n.setAttribute(
              'title',
              ((e = t.type),
              'Secure '.concat(e.split('-').join(' '), ' input frame')),
            ),
            n.setAttribute('src', w(t)),
            n.setAttribute('frameborder', '0'),
            n.setAttribute('scrolling', '0'),
            n.setAttribute('allowtransparency', 'true'),
            n.setAttribute('id', t.fieldId),
            n
          );
        })(
          ((n = e),
          (r = _),
          Object.keys(n)
            .filter(function(t) {
              return r.indexOf(t) >= 0;
            })
            .reduce(function(t, e) {
              return (t[e] = n[e]), t;
            }, {})),
        );
      return (
        ('string' == typeof (o = t) || o instanceof String
          ? document.querySelector(t)
          : t
        ).appendChild(i),
        i
      );
    }
    function E(t, e) {
      function n(n) {
        n.data.messageName === t && e(n.data.payload);
      }
      return window.addEventListener('message', n), n;
    }
    function O(t) {
      return E('fieldReady', t);
    }
    function I(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e &&
          (r = r.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function S(t) {
      for (var e = 0, n = Object.keys(t); e < n.length; e++) {
        var r = n[e];
        console.error(r, t[r].errorMessages);
      }
    }
    n.d(e, 'a', function() {
      return P;
    });
    var T = (function() {
        function t(e, n, r, o, i, a) {
          var s = this;
          h()(this, t),
            (this.type = i),
            (this.modules = a),
            (this._iframe = e),
            (this.fieldId = n),
            r &&
              O(function(t) {
                t.fieldId === s.fieldId &&
                  s._postMessage({
                    messageName: 'setProperties',
                    additionalProperties: r,
                  });
              }),
            o &&
              O(function(t) {
                t.fieldId === s.fieldId &&
                  s._postMessage({
                    messageName: 'setAllowedDomains',
                    allowedDomains: o,
                  });
              });
        }
        return (
          g()(t, [
            {
              key: 'delete',
              value: function() {
                var t = this;
                return (
                  this._postMessage({ messageName: 'delete' }),
                  O(function(e) {
                    e.fieldId === t.fieldId &&
                      t._postMessage({ messageName: 'delete' });
                  }),
                  this
                );
              },
            },
            {
              key: 'mask',
              value: function(t) {
                var e = this,
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : null,
                  r = arguments.length > 2 ? arguments[2] : void 0,
                  o = ['text', 'textarea', 'password', 'zip-code'];
                if (-1 === o.indexOf(this.type))
                  throw new Error(
                    '.mask() available only for the following type of fields: text, textarea, password, zip-code',
                  );
                return (
                  t &&
                    O(function(o) {
                      o.fieldId === e.fieldId &&
                        e._postMessage({
                          messageName: 'setInputMask',
                          mask: { mask: t, maskChar: n, formatChars: r },
                        });
                    }),
                  this
                );
              },
            },
            {
              key: 'replacePattern',
              value: function(t) {
                var e = this,
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : '',
                  r = ['text', 'textarea', 'password', 'zip-code'];
                if (-1 === r.indexOf(this.type))
                  throw new Error(
                    '.replacePattern() available only for the following type of fields: text, textarea, password, zip-code',
                  );
                return (
                  t &&
                    O(function(r) {
                      r.fieldId === e.fieldId &&
                        e._postMessage({
                          messageName: 'setRegExpPattern',
                          replacePattern: { regExpString: t, newSubStr: n },
                        });
                    }),
                  this
                );
              },
            },
            {
              key: 'focus',
              value: function() {
                this._postMessage('focus');
              },
            },
            {
              key: '_postMessage',
              value: function(t) {
                this._iframe.contentWindow.postMessage(t, '*');
              },
            },
          ]),
          t
        );
      })(),
      j = (function() {
        function t(e, n, r, o, i) {
          var a = this;
          h()(this, t),
            (this.environment = e),
            (this.formId = b()),
            (this.state = {}),
            (this.frames = []),
            (this.encryptParams = {}),
            (this.allowedDomains = r),
            (this.modules = o.join(';') || []),
            (this.vaultUrl = i),
            (function(t) {
              E('update', t);
            })(function(t) {
              var e, r;
              t.formId === a.formId &&
                ((e = t),
                (r = 'formId'),
                (t = Object.keys(e)
                  .filter(function(t) {
                    return -1 === r.indexOf(t);
                  })
                  .reduce(function(t, n) {
                    return (t[n] = e[n]), t;
                  }, {})).delete
                  ? C.call(a, t)
                  : (a.state = f()({}, a.state, l()({}, t.name, t))),
                n(a.state));
            }),
            (this.SERIALIZERS = {
              replace: function(t, e, n) {
                return {
                  name: 'replace',
                  options: { old: t, new: e, count: n },
                };
              },
              keepWhiteSpace: function() {
                return { name: 'replace', options: { old: ' ', new: ' ' } };
              },
              separate: function() {
                var t =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : { monthName: 'month', yearName: 'year' };
                return {
                  name: 'separate',
                  options: { monthName: t.monthName, yearName: t.yearName },
                };
              },
            });
        }
        return (
          g()(t, [
            {
              key: 'field',
              value: function(t, e) {
                e.serializers &&
                  (e.serializers = window.btoa(JSON.stringify(e.serializers)));
                var n,
                  r,
                  o,
                  i,
                  a = b(),
                  s = f()({}, e, {
                    formId: this.formId,
                    fieldId: a,
                    modules: this.modules,
                  }),
                  u = k(
                    t,
                    (s = (function(t) {
                      for (var e = 1; e < arguments.length; e++) {
                        var n = null != arguments[e] ? arguments[e] : {};
                        e % 2
                          ? I(Object(n), !0).forEach(function(e) {
                              l()(t, e, n[e]);
                            })
                          : Object.getOwnPropertyDescriptors
                          ? Object.defineProperties(
                              t,
                              Object.getOwnPropertyDescriptors(n),
                            )
                          : I(Object(n)).forEach(function(e) {
                              Object.defineProperty(
                                t,
                                e,
                                Object.getOwnPropertyDescriptor(n, e),
                              );
                            });
                      }
                      return t;
                    })(
                      {},
                      s,
                      {},
                      ((n = this.vaultUrl),
                      (r =
                        -1 !==
                        (r = n.replace(/^https?:\/\//, '')).indexOf(
                          'verygoodproxy.',
                        )
                          ? r.split('.')
                          : r.split()),
                      {
                        tnt: window.btoa(r[0]),
                        env: window.btoa(r[1] || 'live'),
                      }),
                    )),
                  ),
                  c =
                    ((o = e),
                    (i = x),
                    Object.keys(o)
                      .filter(function(t) {
                        return i.indexOf(t) >= 0;
                      })
                      .reduce(function(t, e) {
                        return (t[e] = o[e]), t;
                      }, {}));
                if (
                  (c.css && (c.css = [c.css]),
                  c.showCardIcon && (c.showCardIcon = [c.showCardIcon]),
                  c.yearLength && !/^(2|4)/.test(c.yearLength))
                )
                  throw new Error('"yearLength" available values: 2 or 4');
                return (
                  (this._baseField = u),
                  this.frames.push(u),
                  new T(u, a, c, this.allowedDomains, e.type)
                );
              },
            },
            {
              key: 'submit',
              value: function(t, e, n, r) {
                var o,
                  i = f()({}, e, { url: this.getUrl(t) });
                null == (o = this.encryptParams) ||
                  ('object' === y()(o) && 0 === Object.keys(o).length) ||
                  ('string' == typeof o && 0 === o.trim().length) ||
                  (i.encrypt = this.encryptParams);
                for (
                  var a = {}, s = 0, u = Object.keys(this.state);
                  s < u.length;
                  s++
                ) {
                  var c = u[s];
                  this.state[c].errorMessages.length > 0 &&
                    (a[c] = this.state[c]);
                }
                var l = r || S;
                if (!(Object.keys(a).length > 0))
                  return (
                    (function(t, e, n) {
                      if (!t) throw new Error('No secure field was found');
                      var r = b('submitCallback'),
                        o = E(r, function(t) {
                          window.removeEventListener('message', o), n(t);
                        });
                      !(function(t, e, n) {
                        t.contentWindow.postMessage(
                          { messageName: e, payload: n },
                          'https://js.verygoodvault.com/vgs-collect/1',
                        );
                      })(t, 'submit', f()({}, e, { callbackId: r }));
                    })(this._baseField, i, function(t) {
                      var e = t.status,
                        r = t.data;
                      n(e, r);
                    }),
                    this
                  );
                l(a);
              },
            },
            {
              key: 'encrypt',
              value: function(t) {
                return (this.encryptParams = t), this;
              },
            },
          ]),
          t
        );
      })();
    function C(t) {
      (this.frames = this.frames.filter(function(e) {
        return e.id !== t.fieldId;
      })),
        0 === this.frames.length
          ? (this._baseField = !1)
          : this._baseField.id === t.fieldId &&
            (this._baseField = this.frames[0]);
      var e = document.getElementById(t.fieldId);
      e.parentNode.removeChild(e), delete this.state[t.name];
    }
    function P(t, e) {
      window.VGSCollect = window.SecureForm = window.VgForm = {
        modules: [],
        load: function(t) {
          return (this.modules = f()(this.modules, t)), this;
        },
        create: function(n, r) {
          if (-1 === Object.keys(t).indexOf(n))
            throw "Environment '" +
              n +
              "' does not exist. Valid choices are: " +
              Object.keys(t).join(', ');
          return new ((function(e) {
            function n() {
              return h()(this, n), o()(this, a()(n).apply(this, arguments));
            }
            return (
              u()(n, e),
              g()(n, [
                {
                  key: 'getUrl',
                  value: function(e) {
                    var n = t[this.environment];
                    return ''.concat(n).concat(e);
                  },
                },
              ]),
              n
            );
          })(j))(n, r, e, this.modules, t[n]);
        },
      };
    }
  },
  function(t, e) {
    t.exports = function(t) {
      if (void 0 === t)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called",
        );
      return t;
    };
  },
  function(t, e) {
    function n(e, r) {
      return (
        (t.exports = n =
          Object.setPrototypeOf ||
          function(t, e) {
            return (t.__proto__ = e), t;
          }),
        n(e, r)
      );
    }
    t.exports = n;
  },
  ,
  function(t, e, n) {
    n.r(e);
    var r = n(9);
    Object(r.a)({
      tntzvxdaggz: 'https://tntzvxdaggz.live.verygoodproxy.com',
      tntdehirsr4: 'https://tntdehirsr4.sandbox.verygoodproxy.com',
      tntzdhyyfg9: 'https://tntzdhyyfg9.sandbox.verygoodproxy.com',
      tntajtv6zty: 'https://tntajtv6zty.live.verygoodproxy.com',
    });
  },
]);/* eslint-disable no-underscore-dangle */
var generateUUID = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
var MoonPay = /** @class */ (function () {
    function MoonPay() {
    }
    MoonPay.initialize = function (apiKey, customerId) {
        if (customerId === void 0) { customerId = ''; }
        if (!apiKey.includes('pk')) {
            throw new Error('Invalid MoonPay API key');
        }
        this.apiKey = apiKey;
        this.customerId = customerId;
        this.liveMode = apiKey.includes('live');
        this.sessionId = generateUUID();
        this.initializeSardine();
        this.initializeSift();
        if (document.readyState === 'complete') {
            this.attachSardineSDKToBody();
            this.attachSiftSDKToBody();
            return;
        }
        window.addEventListener('load', this.attachSardineSDKToBody.bind(this), false);
        window.addEventListener('load', this.attachSiftSDKToBody.bind(this), false);
    };
    MoonPay.setCustomerId = function (customerId) {
        this.customerId = customerId;
        if (!window._sift) {
            window._sift = [];
        }
        window._sift.push(['_setUserId', this.customerId]);
    };
    MoonPay.trackPageView = function () {
        if (!window._sift) {
            window._sift = [];
        }
        window._sift.push(['_trackPageview']);
    };
    MoonPay.createCardDetailsForm = function (formCallback) {
        var form = window.VGSCollect.create(this.getVGSVaultID(), formCallback);
        var oldSubmit = form.submit.bind(form);
        form.createField = form.field;
        form.field = undefined;
        form.submit = function submit(billingAddress, callback, errorCallback) {
            oldSubmit("/v3/tokens?apiKey=" + this.apiKey, {
                data: {
                    billingAddress: billingAddress,
                },
            }, callback, errorCallback);
        };
        form.submit = form.submit.bind(this);
        return form;
    };
    MoonPay.createCardCvcForm = function (formCallback) {
        var form = window.VGSCollect.create(this.getVGSVaultID(), formCallback);
        var oldSubmit = form.submit.bind(form);
        form.createField = form.field;
        form.field = undefined;
        form.submit = function submit(callback, errorCallback) {
            oldSubmit("/v3/cvc_tokens?apiKey=" + this.apiKey, {}, callback, errorCallback);
        };
        form.submit = form.submit.bind(this);
        return form;
    };
    MoonPay.initializeSardine = function () {
        // eslint-disable-next-line
        var sardine = (window._sardine = window._sardine || []);
        sardine.push(['sessionKey', this.sessionId]);
        sardine.push(['clientId', 'f469f9ba-d8a0-48ad-8be9-bdf9245c2759']);
        sardine.push(['flow', 'moonpay_signin']);
        sardine.push(['bm', 'on']);
        sardine.push(['userIdHash', this.customerId]);
    };
    MoonPay.initializeSift = function () {
        // eslint-disable-next-line
        var sift = (window._sift = window._sift || []);
        sift.push(['_setAccount', this.liveMode ? '5e05348ef6' : 'e8d599c391']);
        sift.push(['_setUserId', this.customerId]);
        sift.push(['_setSessionId', this.sessionId]);
    };
    MoonPay.attachSiftSDKToBody = function () {
        this.attachScriptToBody('https://buy.moonpay.io/s.js');
    };
    MoonPay.attachSardineSDKToBody = function () {
        this.attachScriptToBody('https://buy.moonpay.io/sa.js');
    };
    MoonPay.attachScriptToBody = function (scriptUrl) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = scriptUrl;
        document.body.appendChild(script);
    };
    MoonPay.getVGSVaultID = function () {
        if (window.origin === 'https://buy-test.moonpay.io') {
            return this.liveMode ? 'tntzvxdaggz' : 'tntdehirsr4';
        }
        return this.liveMode ? 'tntajtv6zty' : 'tntzdhyyfg9';
    };
    return MoonPay;
}());export default MoonPay;